<!--<template>-->
<!--  <div id="app" class="bg-blue-300">je suis ici</div>-->
<!--</template>-->

<!--<script>-->
<!--export default {-->
<!--  name: "App"-->
<!--}-->
<!--</script>-->

<!--<style scoped>-->
<!--#app {-->
<!--  font-size: 1.5rem;-->
<!--}-->
<!--</style>-->

<template>
  <!--
    This example requires updating your template:

    ```
    <html class="h-full bg-gray-100">
    <body class="h-full">
    ```
  -->
  <div class="min-h-full">

    <!--    bg-white opacity-40-->
    <!--    <div v-show="blockUI" class="flex overflow-hidden fixed top-0 right-0 bottom-0 left-0 z-30 flex-col justify-center items-center w-full h-screen">-->
    <!--      <div class="flex flex-col justify-center items-center p-4 w-1/3 text-white bg-gray-700 rounded-2xl opacity-75 sm:w-1/5">-->
    <!--        <div class="mb-2 w-6 h-6 rounded-full border-t-2 border-b-2 animate-spin border-ternary-400"></div>-->
    <!--        <h2 class="text-xl font-semibold text-center animate-pulse">Loading...</h2>-->
    <!--        <p class="text-center animate-pulse">This may take a few seconds, please wait.</p>-->
    <!--      </div>-->
    <!--    </div>-->

    <simple-loader v-show="blockUI" class="fixed inset-0 z-30 w-full h-screen"></simple-loader>

    <!-- When the mobile menu is open, add `overflow-hidden` to the `body` element to prevent double scrollbars -->
    <Popover as="template" v-slot="{ open }" style="background-color: #1d2a31" ref="main-header">

      <header
          :class="[open ? 'fixed inset-0 z-20 overflow-y-auto' : '', 'bg-white shadow-sm lg:static lg:overflow-y-visible']"
          class="py-2 lg:py-0"
      >
        <div class="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
          <div class="flex relative justify-between xl:grid xl:grid-cols-10 lg:gap-8">

            <!-- Logo -->
            <div class="flex  md:left-0 md:inset-y-0 lg:static xl:col-span-3">
              <div class="flex flex-shrink-0 items-center">
                <a href="/">

                  <!-- Desktop logo -->
                  <svg class="mx-auto h-10 w-auto hidden lg:block" viewBox="0 0 85 23" xmlns="http://www.w3.org/2000/svg">
                    <g transform="matrix(.06126 0 0 .06126 7.069 2.501)">
                      <path
                          d="m164 186c21.4 0 38.7-17.3 38.7-38.7s-17.3-38.7-38.7-38.7c-20.1-2.14-59.6-15-64.2-62.7 0-21.4-17.3-38.7-38.7-38.7s-38.7 17.3-38.7 38.7 17.3 38.7 38.7 38.7c20.4 1.77 64.4 15.5 64.2 62.7 0.19 47.2-43.9 59.7-64.5 61.9-21.4 0-38.7 17.3-38.7 38.7s17.3 38.7 38.7 38.7 38.7-17.3 38.7-38.7c7.46-44.2 44.5-61 64.5-61.9"
                          fill="#ffffff" stroke="#000" stroke-width=".265px"/>
                      <circle cx="-35.9" cy="147" r="38.7" fill="#ffffff" fill-rule="evenodd" style="paint-order:stroke fill markers"/>
                    </g>
                    <g transform="matrix(.1378 0 0 .1378 -80.97 -45.28)" stroke-width=".118">
                      <path
                          d="m770 449c-8.25-1.77-17.5-6.22-20.4-14.6 3.66-2.14 7.34-4.24 11-6.35 4.45 7.59 15.2 11.9 22.8 6.23 7.47-8.45-5.17-14.3-11.9-16.6-8.34-3.32-17.2-9.37-17.7-19.2-1.94-10.6 6.73-21.3 17.5-21.7 8.88-1.24 19.2 1.64 23.5 10.2-1.33 3.54-6.62 5.04-9.74 7.58-3.05-4.55-12.6-9.15-16.7-2.29-3.72 10.4 10.3 12.3 16.8 16.1 8.07 3.59 15.5 11.1 14.7 20.6 0.751 10-7.81 18.4-17.4 19.8-3.9 1.16-8.36 0.636-12.4 0.354zm129 0.0547c-14.7-14.5-30.3-28-44.4-43.1-0.428 6.67 0.258 14.1 0.146 21 0.0706 7.1 0.137 14.2 0.206 21.3h-13.1c0.121-23.7-0.299-47.3 0.295-71 5.06 1.84 10.6 9.18 15.6 13.2 10 9.44 20.1 18.9 29.5 28.9 0.587-6.82-0.299-14.4-0.123-21.5-0.0809-6.84-0.158-13.7-0.237-20.5h13.1c-0.0466 23.7 0.386 47.4-0.0934 71.1 0.228 0.519-0.524 1.33-0.958 0.548zm-87.1-36.2v-35.5h14.1v70.9h-14.1v-35.5zm104-3e-3v-35.5c15.6 0.0605 31.2 0.121 46.7 0.181v11.6c-10.7 0.186-21.5-0.198-32.2 0.576-0.961 7.56-0.305 15.3-0.384 23 9.55 0.256 19.1 0.307 28.7 0.451v11.6c-9.52 0.118-19 0.235-28.6 0.353v10.6c11.3 0.118 22.6 0.235 33.9 0.353 0.0643 4.06 0.129 8.11 0.193 12.2h-48.3v-35.5z"
                          fill="#ffffff"/>
                      <path
                          d="m1007 449c0-0.169-0.833-0.417-1.85-0.55-2.65-0.347-7.78-2.13-10.8-3.75-12.3-6.63-19.5-19.7-18.6-34.2 0.79-13.9 8.96-25.7 21.4-31.1 10.1-4.33 21.8-4.14 31.7 0.523 4.38 2.07 7.08 4.03 10.5 7.57 4.22 4.42 6.7 8.75 8.6 15 0.906 2.99 0.963 3.58 0.968 10.1 0 7.56-0.324 9.45-2.59 14.9-2.3 5.52-7.4 11.8-12.3 15.1-4.32 2.9-12.2 6.01-15.2 6.01-0.404 0-0.735 0.159-0.735 0.353 0 0.22-2.06 0.353-5.47 0.353-3.01 0-5.47-0.138-5.47-0.307zm11.1-13c7.03-1.7 13.4-7.94 15.5-15.3 0.972-3.31 1.36-7.82 0.956-11.1-1.2-9.77-6.59-16.9-15-19.8-2.45-0.852-3.35-0.977-7.04-0.986-3.4-8e-3 -4.72 0.142-6.7 0.765-7.12 2.24-12.8 8.33-14.9 16-0.46 1.68-0.628 3.61-0.632 7.23-4e-3 4.2 0.119 5.33 0.821 7.58 2.07 6.62 5.99 11.5 11.4 14.1 5.02 2.41 10.2 2.94 15.6 1.61zm44.5 11.8c-0.092-0.243-0.127-16.2-0.077-35.4l0.091-34.9 11.6-0.11c12.6-0.119 16 0.136 21 1.58 9.02 2.6 15.2 8.58 17.5 16.9 0.868 3.15 1.07 11 0.374 14.3-1.26 6.01-5.03 11.3-10.2 14.3-1.33 0.765-2.48 1.58-2.57 1.82-0.09 0.235 3.02 5.2 6.92 11 3.89 5.84 7.08 10.7 7.08 10.8 0 0.103-3.61 0.145-8.03 0.0925l-8.03-0.0938-2-3c-1.1-1.65-3.72-5.62-5.82-8.82l-3.82-5.82-4.54-0.099c-3.04-0.0664-4.7 0.0349-5.03 0.308-0.394 0.327-0.49 2.1-0.49 9.01v8.6h-6.89c-5.19 0-6.93-0.109-7.06-0.441zm27.3-30.4c6.39-1.81 9.36-6.09 9.36-13.5 0-8.71-4.01-13.2-12.9-14.3-4.01-0.503-8.87-0.473-9.4 0.0565-0.315 0.315-0.423 3.96-0.423 14.2 0 7.59 0.119 13.9 0.265 14.1 0.441 0.457 11-0.0517 13.1-0.628zm32.2 30.4c0.015-0.247 6.96-16.3 15.4-35.7 9.66-22.1 15.6-35.3 15.9-35.3 0.299 0 6.52 13.3 16.3 34.9 8.71 19.2 15.9 35.3 16 35.7l0.206 0.794h-7.05c-5.23 0-7.14-0.114-7.38-0.441-0.183-0.243-0.938-1.91-1.68-3.7-0.739-1.79-1.54-3.42-1.78-3.62-0.286-0.237-5.45-0.33-15-0.269l-14.6 0.0922-3.26 7.76-6.58 0.096c-5.16 0.0751-6.58 0-6.56-0.353zm40.5-20.1c0.066-0.344-1.18-3.76-2.78-7.58-1.59-3.83-3.6-9.1-4.45-11.7-0.852-2.62-1.68-4.89-1.83-5.04-0.495-0.495-0.954 0.49-2.59 5.57-0.878 2.72-2.87 8.01-4.44 11.8-1.56 3.75-2.76 7.05-2.65 7.33 0.161 0.42 1.7 0.486 9.41 0.408 8.5-0.0867 9.23-0.143 9.34-0.72z"
                          fill="#ffffff"/>
                    </g>
                  </svg>

                  <!-- Mobile logo -->
                  <svg class=" mx-auto h-8 w-auto lg:hidden" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
                    <g fill="#FFFFFF">
                      <path d="m9.9 7.5c0.82 0 1.5-0.67 1.5-1.5s-0.67-1.5-1.5-1.5c-0.77-0.082-2.3-0.58-2.5-2.4 0-0.82-0.67-1.5-1.5-1.5-0.82 0-1.5 0.67-1.5 1.5s0.67 1.5 1.5 1.5c0.79 0.068 2.5 0.6 2.5 2.4 0.0073 1.8-1.7 2.3-2.5 2.4-0.82 0-1.5 0.67-1.5 1.5 0 0.82 0.67 1.5 1.5 1.5 0.82 0 1.5-0.67 1.5-1.5 0.29-1.7 1.7-2.3 2.5-2.4"/>
                      <circle cx="2.1" cy="6" r="1.5" fill-rule="evenodd" style="paint-order:stroke fill markers"/>
                    </g>
                  </svg>

                </a>
              </div>
            </div>

            <!-- Mobile sidebar button -->
            <div class="flex items-center pl-5 lg:hidden">
              <button type="button" class="h-12 w-8 inline-flex items-center justify-center rounded-md text-gray-50 hover:text-gray-900 hover:bg-gray-50" @click="sidebarOpen = true">
                <span class="sr-only">Open sidebar</span>
                <MenuIcon class="h-8 w-8" aria-hidden="true" />
              </button>
            </div>

            <!-- Search bar -->
            <div class="flex-1 min-w-0 md:px-8 lg:px-0 xl:col-span-5">
              <div class="flex items-center pl-5 py-4 md:max-w-3xl md:mx-auto lg:max-w-none lg:mx-0 xl:px-0">
                <div class="w-full">
                  <label for="search" class="sr-only">Search</label>
                  <div class="relative">
                    <div class="flex absolute inset-y-0 left-0 items-center pl-3 pointer-events-none">
                      <SearchIcon class="w-5 h-5 text-gray-400" aria-hidden="true"/>
                    </div>
                    <input id="search"
                           name="search"
                           class="block py-2 pr-3 pl-10 w-full text-sm placeholder-gray-500 bg-white rounded-md border border-gray-300 focus:outline-none focus:text-gray-900 focus:placeholder-gray-400 focus:ring-1 focus:ring-primary focus:border-primary sm:text-sm"
                           placeholder="Type new company name or keyword"
                           type="search"
                           v-on:keyup="searchTimeout()"
                           v-model="searchTerms"
                           ref="search-bar"
                    />
                  </div>
                </div>
              </div>
            </div>

<!--            &lt;!&ndash; Mobile navigation menu &ndash;&gt;
            <div class="flex items-center md:absolute md:right-0 md:inset-y-0 lg:hidden">
              <PopoverButton
                  class="inline-flex justify-center items-center p-2 -mx-2 text-gray-400 rounded-md hover:bg-gray-100 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary">
                <span class="sr-only">Open menu</span>
                <MenuIcon v-if="!open" class="block w-6 h-6" aria-hidden="true"/>
                <XIcon v-else class="block w-6 h-6" aria-hidden="true"/>
              </PopoverButton>
            </div>-->

            <!-- Left actions -->
            <div class="flex items-center justify-end xl:col-span-2">
              <!-- Notifications Button -->
              <button type="button"
                      @click="openNotificationCenter=true"
                      class="relative flex-shrink-0 p-1 ml-5 text-gray-400 bg-white rounded-full hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-primary">
                <span class="sr-only">View notifications</span>
                <BellIcon class="w-6 h-6" aria-hidden="true"/>
                <span
                    v-show="notificationCount > 0"
                    class="bg-green-300 text-green-900 absolute -top-2 -right-2 block h-6 w-6 rounded-full" aria-hidden="true">{{ notificationCount }}</span>
              </button>

              <!-- Profile dropdown -->
              <Menu as="div" class="relative flex-shrink-0 ml-5">
                <div>
                  <MenuButton class="flex bg-white rounded-full focus:outline-none focus:ring-2 focus:ring-primary">
                    <span class="sr-only">Open user menu</span>
                    <span class="inline-block overflow-hidden w-8 h-8 rounded-full shadow">
                      <svg class="w-full h-full text-gray-300" fill="currentColor" viewBox="0 0 24 24">
                        <path
                            d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z"/>
                      </svg>
                    </span>
                  </MenuButton>
                </div>
                <transition enter-active-class="transition duration-100 ease-out"
                            enter-from-class="opacity-0 transform scale-95"
                            enter-to-class="opacity-100 transform scale-100"
                            leave-active-class="transition duration-75 ease-in"
                            leave-from-class="opacity-100 transform scale-100"
                            leave-to-class="opacity-0 transform scale-95">
                  <MenuItems
                      class="absolute right-0 z-20 py-1 mt-2 w-48 bg-white rounded-md ring-1 ring-black ring-opacity-5 shadow-lg origin-top-right focus:outline-none">
                    <MenuItem v-for="item in userNavigation" :key="item.name" v-slot="{ active }">
                      <a v-if="item.href !== undefined && item.href !== null"
                         :href="item.href"
                         :class="[active ? 'bg-gray-100' : '', 'block py-2 px-4 text-sm text-gray-700']">
                        {{ item.name }}
                      </a>
                      <button v-else
                         @click="item.onClickCallback(this)"
                         :class="[active ? 'bg-gray-100' : '', 'block w-full text-left py-2 px-4 text-sm text-gray-700']">
                        {{ item.name }}
                      </button>
                    </MenuItem>
                  </MenuItems>
                </transition>
              </Menu>
            </div>

          </div>
        </div>

<!--        &lt;!&ndash; Mobile menu &ndash;&gt;
        <PopoverPanel as="nav" class="lg:hidden" aria-label="Global">
&lt;!&ndash;          <div class="px-2 pt-2 pb-3 mx-auto space-y-1 max-w-3xl sm:px-4">&ndash;&gt;
&lt;!&ndash;            <a v-for="item in navigation" :key="item.name" :href="item.href"&ndash;&gt;
&lt;!&ndash;               :aria-current="item.current ? 'page' : undefined"&ndash;&gt;
&lt;!&ndash;               :class="[item.current ? 'bg-gray-100 text-gray-900' : 'hover:bg-gray-50', 'block rounded-md py-2 px-3 text-base font-medium']">{{&ndash;&gt;
&lt;!&ndash;                item.name&ndash;&gt;
&lt;!&ndash;              }}</a>&ndash;&gt;
&lt;!&ndash;          </div>&ndash;&gt;
          <div class="pt-4 border-t border-gray-200">
            <div class="flex items-center px-4 mx-auto max-w-3xl sm:px-6">
&lt;!&ndash;              <div class="flex-shrink-0">&ndash;&gt;
&lt;!&ndash;                    <span class="inline-block overflow-hidden w-10 h-10 rounded-full shadow">&ndash;&gt;
&lt;!&ndash;                      <svg class="w-full h-full text-gray-300" fill="currentColor" viewBox="0 0 24 24">&ndash;&gt;
&lt;!&ndash;                        <path&ndash;&gt;
&lt;!&ndash;                            d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z"/>&ndash;&gt;
&lt;!&ndash;                      </svg>&ndash;&gt;
&lt;!&ndash;                    </span>&ndash;&gt;
&lt;!&ndash;&lt;!&ndash;                <img class="w-10 h-10 rounded-full" :src="user.imageUrl" alt=""/>&ndash;&gt;&ndash;&gt;
&lt;!&ndash;              </div>&ndash;&gt;
&lt;!&ndash;              <div class="ml-3">&ndash;&gt;
&lt;!&ndash;                <div class="text-base font-medium text-gray-800">{{ user.name }}</div>&ndash;&gt;
&lt;!&ndash;                <div class="text-sm font-medium text-gray-500">{{ user.email }}</div>&ndash;&gt;
&lt;!&ndash;              </div>&ndash;&gt;
              <button type="button"
                      @click="openNotificationCenter=true"
                      class="flex-shrink-0 p-1 ml-auto text-gray-400 bg-white rounded-full hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-primary">
                <span class="sr-only">View notifications</span>
                <BellIcon class="w-6 h-6" aria-hidden="true"/>
              </button>
            </div>
            <div class="px-2 mx-auto mt-3 space-y-1 max-w-3xl sm:px-4">
              <a v-for="item in userNavigation" :key="item.name" :href="item.href"
                 class="block px-3 py-2 text-base font-medium text-gray-50 rounded-md hover:bg-gray-50 hover:text-gray-900">{{
                  item.name
                }}</a>
            </div>
          </div>

&lt;!&ndash;          <div class="px-4 mx-auto mt-6 max-w-3xl sm:px-6">&ndash;&gt;
&lt;!&ndash;            <button&ndash;&gt;
&lt;!&ndash;                class="flex justify-center items-center px-4 py-2 w-full text-base font-medium text-white bg-rose-600 rounded-md border border-transparent shadow-sm hover:bg-rose-700">&ndash;&gt;
&lt;!&ndash;              New Post&ndash;&gt;
&lt;!&ndash;            </button>&ndash;&gt;

&lt;!&ndash;&lt;!&ndash;            <div class="flex justify-center mt-6">&ndash;&gt;&ndash;&gt;
&lt;!&ndash;&lt;!&ndash;              <button class="text-base font-medium text-white hover:underline">&ndash;&gt;&ndash;&gt;
&lt;!&ndash;&lt;!&ndash;                Go Premium&ndash;&gt;&ndash;&gt;
&lt;!&ndash;&lt;!&ndash;              </button>&ndash;&gt;&ndash;&gt;
&lt;!&ndash;&lt;!&ndash;            </div>&ndash;&gt;&ndash;&gt;
&lt;!&ndash;          </div>&ndash;&gt;
        </PopoverPanel>-->
      </header>
    </Popover>


    <div class="py-4">

      <TransitionRoot as="template" :show="sidebarOpen">
        <Dialog as="div" class="relative z-40 lg:hidden" @close="sidebarOpen = false">
          <TransitionChild as="template" enter="transition-opacity ease-linear duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="transition-opacity ease-linear duration-300" leave-from="opacity-100" leave-to="opacity-0">
            <div class="fixed inset-0 bg-gray-800 bg-opacity-80" />
          </TransitionChild>

          <div class="fixed inset-0 flex z-40">
            <TransitionChild as="template" enter="transition ease-in-out duration-300 transform" enter-from="-translate-x-full" enter-to="translate-x-0" leave="transition ease-in-out duration-300 transform" leave-from="translate-x-0" leave-to="-translate-x-full">
              <DialogPanel class="relative flex-1 flex flex-col max-w-xs w-full bg-white focus:outline-none">
                <TransitionChild as="template" enter="ease-in-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in-out duration-300" leave-from="opacity-100" leave-to="opacity-0">
                  <div class="absolute top-0 right-0 -mr-12 pt-2">
                    <button type="button" class="ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white" @click="sidebarOpen = false">
                      <span class="sr-only">Close sidebar</span>
                      <XIcon class="h-6 w-6 text-white" aria-hidden="true" />
                    </button>
                  </div>
                </TransitionChild>
                <div class="flex-1 h-0 pl-1 pr-3 overflow-y-auto bg-past-blue">
<!--                  <nav aria-label="Sidebar" class="mt-5">-->
<!--                    <div class="px-2 space-y-1">-->
<!--                      <a v-for="item in navigation" :key="item.name" :href="item.href" :class="[item.current ? 'bg-gray-100 text-gray-900' : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900', 'group flex items-center px-2 py-2 text-base font-medium rounded-md']">-->
<!--                        <component :is="item.icon" :class="[item.current ? 'text-gray-500' : 'text-gray-400 group-hover:text-gray-500', 'mr-4 h-6 w-6']" aria-hidden="true" />-->
<!--                        {{ item.name }}-->
<!--                      </a>-->
<!--                    </div>-->
<!--                  </nav>-->
                  <nav aria-label="Sidebar" class="sticky divide-y divide-gray-300 overflow-y-auto hidden-scrollbar">
                    <!--            <div class="pb-8 space-y-1">-->
                    <div class="pb-8" @click="sidebarOpen = false;">
                      <template v-for="item in navigation" :key="item.name" >
                        <action-button-nav v-if="item.type === 'button'"
                                           :nav-item="item"
                                           @click="item.onClickCallback(this); sidebarOpen = false">
                        </action-button-nav>
                        <item-nav v-else-if="!item.children" :nav-item="item"></item-nav>
                        <section-nav v-else-if="item.section !== undefined" :nav-item="item"></section-nav>
                        <complex-item-nav v-else :nav-item="item"></complex-item-nav>
                      </template>
                    </div>
                  </nav>
                </div>
              </DialogPanel>
            </TransitionChild>
            <div class="flex-shrink-0 w-14" aria-hidden="true">
              <!-- Force sidebar to shrink to fit close icon -->
            </div>
          </div>
        </Dialog>
      </TransitionRoot>














<!--      <div class="mx-auto max-w-3xl sm:px-6 lg:max-w-screen-2xl lg:px-8 lg:grid lg:grid-cols-12 lg:gap-8">-->
      <div class="mx-auto max-w-3xl sm:px-6 lg:max-w-screen-xl lg:px-8 lg:grid lg:grid-cols-10 lg:gap-8">
        <div class="hidden lg:block lg:col-span-3 xl:col-span-3">
          <nav aria-label="Sidebar" class="sticky top-4 divide-y divide-gray-300 overflow-y-auto hidden-scrollbar" :style="`max-height: calc(100vh - ${headerHeight}px);`">
            <!--            <div class="pb-8 space-y-1">-->
            <div class="pb-8">
              <template v-for="item in navigation" :key="item.name">
                <action-button-nav v-if="item.type === 'button'"
                                   :nav-item="item"
                                   @click="item.onClickCallback(this)">
                </action-button-nav>
                <item-nav v-else-if="!item.children" :nav-item="item"></item-nav>
                <section-nav v-else-if="item.section !== undefined" :nav-item="item"></section-nav>
                <complex-item-nav v-else :nav-item="item"></complex-item-nav>
              </template>
            </div>
          </nav>
        </div>
<!--        <main class="lg:col-span-9 xl:col-span-6">-->
        <main class="col-span-7">
          <!-- Tabs -->
<!--          <div class="px-4 sm:px-0">-->
<!--            <div class="sm:hidden">-->
<!--              <label for="question-tabs" class="sr-only">Select a tab</label>-->
<!--              <select id="question-tabs"-->
<!--                      class="block w-full text-base font-medium text-gray-900 rounded-md border-gray-300 shadow-sm focus:border-primary focus:ring-primary">-->
<!--                <option v-for="tab in tabs" :key="tab.name" :selected="tab.current">{{ tab.name }}</option>-->
<!--              </select>-->
<!--            </div>-->
<!--            <div class="hidden sm:block">-->
<!--              <nav class="flex relative z-0 rounded-lg divide-x divide-gray-200 shadow" aria-label="Tabs">-->
<!--                <a v-for="(tab, tabIdx) in tabs"-->
<!--                   :key="tab.name"-->
<!--                   :href="tab.href"-->
<!--                   :aria-current="tab.current ? 'page' : undefined"-->
<!--                   :class="[tab.current ? 'text-gray-900' : 'text-gray-500 hover:text-gray-700', tabIdx === 0 ? 'rounded-l-lg' : '', tabIdx === tabs.length - 1 ? 'rounded-r-lg' : '', 'group relative min-w-0 flex-1 overflow-hidden bg-white py-4 px-6 text-sm font-medium text-center hover:bg-gray-50 focus:z-10']">-->
<!--                  <span>{{ tab.name }}</span>-->
<!--                  <span aria-hidden="true"-->
<!--                        :class="[tab.current ? 'bg-primary' : 'bg-transparent', 'absolute inset-x-0 bottom-0 h-0.5']"/>-->
<!--                </a>-->
<!--              </nav>-->
<!--            </div>-->
<!--          </div>-->

          <!-- Filters -->
          <Disclosure v-if="currentViewChannel === null"
                      as="section" aria-labelledby="filter-heading"
                      class="grid relative z-10 items-center mt-4 bg-white border-t border-b border-gray-200">
            <h2 id="filter-heading" class="sr-only">Filters</h2>
            <div class="relative col-start-1 row-start-1 py-4">
              <div class="flex px-4 mx-auto space-x-6 max-w-7xl text-sm divide-x divide-gray-200 sm:px-6 lg:px-8">
                <div>
                  <DisclosureButton class="flex items-center font-medium text-gray-700 group">
                    <FilterIcon class="flex-none mr-2 w-5 h-5 text-gray-400 group-hover:text-gray-500"
                                aria-hidden="true"/>
                    <span v-if="countSelectedFilters > 0">{{ countSelectedFilters }}&nbsp;</span>Advanced Filters
                  </DisclosureButton>
                </div>
                <div class="pl-6">
                  <button type="button" class="text-gray-500" @click="clearFilters($event, 'all')">Clear all</button>
                </div>
              </div>
            </div>
            <DisclosurePanel class="py-10 border-t border-gray-200">
              <div v-if="filters"
                   class="grid grid-cols-2 gap-x-4 px-4 mx-auto max-w-7xl text-sm sm:px-6 md:gap-x-6 lg:px-8">
                <div class="grid grid-cols-1 auto-rows-min gap-y-10 md:grid-cols-2 md:gap-x-6">
                  <fieldset class="grid pr-1 pb-2 pl-2 rounded border-2 border-gray-300">
                    <legend class="flex justify-between px-1 w-11/12 font-medium">
                      <span>{{ filters.tag.label }}</span>
                      <button type="button" class="text-gray-500" @click="clearFilters($event, 'tag')">Clear</button>
                    </legend>
                    <input type="text"
                           class="px-1 py-0 mt-1 w-11/12 text-sm rounded border outline-none focus:border-primary"
                           placeholder="Search" v-model="iTagSearchValue" @click="iTagSearchValue = ''"/>
                    <div class="overflow-y-auto overflow-x-hidden mt-3 space-y-6 h-32 sm:space-y-2">
                      <div v-for="(option, optionIdx) in iFilteredTags" :key="option.value"
                           class="flex items-center min-w-0 text-base sm:text-sm pl-1">
                        <input :id="`tag-${option.value}`"
                               :value="option.value"
                               :checked="option.checked"
                               @input="option.checked = ! option.checked;  useTag(option.value, option.checked); search(true);"
                               name="tag[]"
                               type="checkbox"
                               class="flex-shrink-0 w-4 h-4 text-secondary rounded border-gray-300 focus:ring-secondary"/>
                        <label :for="`tag-${option.value}`" class="flex-1 ml-2 min-w-0 text-gray-600">
                          {{ option.label }}
                        </label>
                      </div>
                    </div>
                  </fieldset>
                  <fieldset class="pr-1 pb-2 pl-2 rounded border-2 border-gray-300">
                    <legend class="flex justify-between px-1 w-11/12 font-medium">
                      <span>{{ filters.location.label }}</span>
                      <button type="button" class="text-gray-500" @click="clearFilters($event, 'location')">Clear
                      </button>
                    </legend>
                    <div class="overflow-y-auto mt-3 space-y-6 h-44 sm:space-y-2">
                      <div v-for="(option, optionIdx) in filters.location.options" :key="option.value"
                           class="flex items-center text-base sm:text-sm pl-1">
                        <input :id="`location-${optionIdx}`"
                               :value="option.value"
                               :checked="option.checked"
                               @input="option.checked = ! option.checked; selectFiltersOption('location', option.value, option.checked); search(true);"
                               name="location[]"
                               type="checkbox"
                               class="flex-shrink-0 w-4 h-4 text-secondary rounded border-gray-300 focus:ring-secondary"/>
                        <label :for="`location-${optionIdx}`" class="flex-1 ml-2 min-w-0 text-gray-600">
                          {{ option.label }}
                        </label>
                      </div>
                    </div>
                  </fieldset>
                </div>
                <div class="grid grid-cols-1 auto-rows-min gap-y-10 md:grid-cols-2 md:gap-x-6">
                  <fieldset class="pr-1 pb-2 pl-2 rounded border-2  border-gray-300">
                    <legend class="flex justify-between px-1 w-11/12 font-medium">
                      <span>{{ filters.size.label }}</span>
                      <button type="button" class="text-gray-500" @click="clearFilters($event, 'size')">Clear</button>
                    </legend>
                    <div class="overflow-y-auto mt-3 space-y-6 h-44 sm:space-y-2">
                      <div v-for="(option, optionIdx) in filters.size.options" :key="option.value"
                           class="flex items-center text-base sm:text-sm pl-1">
                        <input :id="`size-${optionIdx}`"
                               :value="option.value"
                               :checked="option.checked"
                               @input="option.checked = ! option.checked; selectFiltersOption('size', option.value, option.checked); search(true);"
                               name="size[]"
                               type="checkbox"
                               class="flex-shrink-0 w-4 h-4 text-secondary rounded border-gray-300 focus:ring-secondary"/>
                        <label :for="`size-${optionIdx}`" class="flex-1 ml-2 min-w-0 text-gray-600">
                          {{ option.label }}
                        </label>
                      </div>
                    </div>
                  </fieldset>
                  <fieldset class="pr-1 pb-2 pl-2 rounded border-2 border-gray-300">
                    <legend class="flex justify-between px-1 w-11/12 font-medium">
                      <span>{{ filters.age.label }}</span>
                      <button type="button" class="text-gray-500" @click="clearFilters($event, 'age')">Clear</button>
                    </legend>
                    <div class="overflow-y-auto mt-3 space-y-6 h-44 sm:space-y-2">
                      <div v-for="(option, optionIdx) in filters.age.options" :key="option.value"
                           class="flex items-center text-base sm:text-sm pl-1">
                        <input :id="`age-${optionIdx}`"
                               :value="option.value"
                               :checked="option.checked"
                               @input="option.checked = ! option.checked; selectFiltersOption('age', option.value, option.checked); search(true);"
                               name="age[]"
                               type="checkbox"
                               class="flex-shrink-0 w-4 h-4 text-secondary rounded border-gray-300 focus:ring-secondary"/>
                        <label :for="`age-${optionIdx}`" class="flex-1 ml-2 min-w-0 text-gray-600">
                          {{ option.label }}
                        </label>
                      </div>
                    </div>
                  </fieldset>
                  <!--                  <fieldset>-->
                  <!--                    <legend class="flex justify-between w-full font-medium">-->
                  <!--                      Category-->
                  <!--                    </legend>-->
                  <!--                    <div class="overflow-y-auto pt-6 space-y-6 h-44 sm:pt-4 sm:space-y-2">-->
                  <!--                      <div v-for="(option, optionIdx) in filters.category" :key="option.value" class="flex items-center text-base sm:text-sm">-->
                  <!--                        <input :id="`category-${optionIdx}`" name="category[]" :value="option.value" type="checkbox" class="flex-shrink-0 w-4 h-4 text-indigo-600 rounded border-gray-300 focus:ring-indigo-500" :checked="option.checked"  @input="selectFiltersOption('location', optionIdx)"/>-->
                  <!--                        <label :for="`category-${optionIdx}`" class="flex-1 ml-3 min-w-0 text-gray-600">-->
                  <!--                          {{ option.label }}-->
                  <!--                        </label>-->
                  <!--                      </div>-->
                  <!--                    </div>-->
                  <!--                  </fieldset>-->
                </div>
              </div>
            </DisclosurePanel>
            <div class="col-start-1 row-start-1 py-4">
              <div class="flex justify-end px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
                <Menu as="div" class="inline-block relative">
                  <div class="flex">
                    <MenuButton class="inline-flex justify-center text-sm font-medium text-gray-700 group hover:text-gray-900">
                      <SortAscendingIcon class="h-5 w-5 text-gray-400 group-hover:text-gray-500" aria-hidden="true" />
                      <span class="ml-1 ">Sort</span>
                      <ChevronDownIcon class="flex-shrink-0 -mr-1 ml-1 w-5 h-5 text-gray-400 group-hover:text-gray-500" aria-hidden="true"/>
                    </MenuButton>
                  </div>

                  <transition enter-active-class="transition duration-100 ease-out"
                              enter-from-class="opacity-0 transform scale-95"
                              enter-to-class="opacity-100 transform scale-100"
                              leave-active-class="transition duration-75 ease-in"
                              leave-from-class="opacity-100 transform scale-100"
                              leave-to-class="opacity-0 transform scale-95">
                    <MenuItems
                        class="absolute right-0 mt-2 w-40 bg-white rounded-md ring-1 ring-black ring-opacity-5 shadow-2xl origin-top-right focus:outline-none">
                      <div class="py-1">
                        <MenuItem v-for="option in sortOptions" :key="option.name" v-slot="{ active }">
                          <button
                              @click="setSearchSort(option); search(true)"
                              :class="[option.current ? 'font-medium text-gray-900' : 'text-gray-500', active ? 'bg-gray-100' : '', 'text-left px-4 py-2 text-sm w-full']">
                            {{ option.name }}
                          </button>
                        </MenuItem>
                      </div>
                    </MenuItems>
                  </transition>
                </Menu>
              </div>
            </div>
          </Disclosure>

          <!-- Search Result Tabs -->
          <div class="mt-4">
            <h1 class="sr-only">Search Result</h1>
            <div class="ml-1 my-4" v-if="searchResult._metadata !== undefined && searchResult._metadata.total > 0">
              <p class="text-sm text-gray-600">
<!--                About-->
<!--                {{ ' ' }}-->
                <span class="">{{ searchResult._metadata.total }}</span>
                {{ '  result' + (searchResult._metadata.total > 1 ? 's': '') }}
              </p>
            </div>

            <div v-if="searchResult._metadata !== undefined && searchResult._metadata.total < 1"
                 class="px-4 py-6 text-sm font-medium text-center text-gray-900 bg-white shadow sm:p-6 sm:rounded-lg">
              No result.
            </div>

            <ul role="list" class="space-y-4">

              <li v-for="company in searchResult.recordset" :key="company.id"
                  class="px-4 py-6 bg-white shadow sm:p-6 sm:rounded-lg">
                <article :aria-labelledby="'company-title-' + company.id">


                  <div class="pb-2 border-b">
                    <!-- Header -->
                    <div class="flex space-x-3">
                      <!-- Logo -->
                      <div class="flex-shrink-0 cursor-pointer" @click="startupPopup($event, company, true)"
                           title="View more information about it">
                        <img class="w-14 h-14 rounded transform hover:scale-150" :src="company.logo" alt="{{ company.name }}"/>
                      </div>

                      <!-- Title -->
                      <div class="flex-1 min-w-0">
                        <div class="font-bold text-gray-900 flex flex-row items-center space-x-2">
                          <button
                              @click="startupPopup($event, company, true)"
                              type="button"
                              title="View more information about it">
                            {{ company.name }}
                          </button>
                          <a :href="company.website_url"
                             rel="noopener noreferrer"
                             target="_blank"
                             class="">
                            <ExternalLinkIcon class="h-4 w-4"></ExternalLinkIcon>
                          </a>
                        </div>
                        <p class="text-xs text-gray-500 mt-1">
                          <time :datetime="company.creation_date">Launched on {{
                              company.creation_localized_date
                            }}
                          </time>
                        </p>
                      </div>

                      <!-- info -->
                      <!-- <div class="flex justify-end content-end min-w-0"
                           :set="upVvote = Math.random() > 0.5 ? Math.floor(Math.random() * (15 - 1)) + 1 : 0"
                           :set2="downVote = Math.random() > 0.5 ? Math.floor(Math.random() * (15 - 1)) + 1 : 0"
                           :set3="ratio = upVvote / (upVvote+downVote)"
                           :set4="attachmentCount = Math.floor(Math.random() * (15 - 1))"
                           :set5="checklistItems = Math.floor(Math.random() * (15 - 1))"
                           :set6="postCount = Math.floor(Math.random() * (15 - 1))">

                        <div class="text-sm content-end" v-if="upVvote > 0">
                          <button class="inline-flex items-center space-x-1 text-gray-500 mr-3"
                                  @click="$store.commit('addNotification', {title: 'Up vote', body: 'Not yet implemented', type:'warning' })">
                            <ThumbUpIcon class="flex-shrink-0 w-4 h-4" aria-hidden="true"/>
                            <span class="font-medium text-gray-900">{{ upVvote }}</span>
                            <span class="sr-only">Up Vote</span>
                          </button>
                        </div>

                        <div class="text-sm content-end" v-if="Math.random() > 0.5" title="This company has a description">
                          <button class="inline-flex items-center space-x-1 text-gray-500 mr-3 mt-0.5"
                                  @click="$store.commit('addNotification', {title: 'See description', body: 'Not yet implemented', type:'warning' })">
                              <svg class="lex-shrink-0 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                <g stroke-dashoffset=".64" stroke-linecap="round" stroke-width="2">
                                  <path d="m1.1 4.6h16"/>
                                  <path d="m1.1 20h12"/>
                                  <path d="m1.1 15h16"/>
                                  <path d="m1.1 9.7h16"/>
                                </g>
                              </svg>
                            <span class="sr-only">See the company description</span>
                          </button>
                        </div>

                        <div class="text-sm content-end"
                             v-if="postCount > 0"
                             title="Comments">
                          <button class="inline-flex items-center space-x-1 text-gray-500 mr-3"
                                  @click="$store.commit('addNotification', {title: 'See attachments', body: 'Not yet implemented', type:'warning' })">
                            <ChatAltIcon class="flex-shrink-0 w-4 h-4" aria-hidden="true"/>
                            <span class="font-medium text-gray-900" >{{ postCount }}</span>
                            <span class="sr-only">See the company comments</span>
                          </button>
                        </div>

                        <div class="text-sm content-end" v-if="checklistItems > 0" title="Checklist items">
                          <button class="inline-flex items-center space-x-1 text-gray-500 mr-3"
                                  @click="$store.commit('addNotification', {title: 'See Checklist Items', body: 'Not yet implemented', type:'warning' })">
                            <svg class="flex-shrink-0 w-4 h-4" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"  aria-hidden="true">
                              <path d="m5.1 3.03c-0.204 1.91e-5 -1.21 0.233-1.84 0.844-0.644 0.628-0.903 1.64-0.902 1.85l0.00584 12.4c8.21e-4 0.205 0.166 1.33 0.832 1.99 0.671 0.672 1.84 0.891 2.05 0.892h12c0.207-1.6e-5 1.36-0.181 2.04-0.819 0.676-0.627 0.895-1.71 0.896-1.91l0.0233-5.48c0.0017-0.413-0.331-0.749-0.744-0.751-0.412-0.0016-0.748 0.332-0.75 0.745l-0.0168 5.48c-0.0557 0.298-0.152 0.572-0.412 0.789-0.136 0.144-0.459 0.37-0.951 0.45h-12.2c-0.351-0.037-0.568-0.15-0.825-0.339-0.252-0.217-0.475-0.528-0.528-0.879l-0.00511-12.5c0.0768-0.384 0.228-0.603 0.404-0.781 0.258-0.306 0.548-0.38 0.773-0.421h12.8c0.412 0 0.747-0.335 0.747-0.748 0-0.413-0.334-0.747-0.747-0.748l-12.7-0.00839zm15.7 2.5a0.857 0.858 0 0 0-0.663 0.258l-9.15 9.42-4.12-4.18a0.857 0.858 0 0 0-1.21-0.0088 0.857 0.858 0 0 0-0.00584 1.21l4.73 4.8a0.857 0.858 0 0 0 1.22-3e-3l9.76-10.1a0.857 0.858 0 0 0-0.0175-1.21 0.857 0.858 0 0 0-0.548-0.241z"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="100"
                                    stroke-width="2"/>
                            </svg>
                            <span class="font-medium text-gray-900">{{ checklistItems }}</span>
                            <span class="sr-only">Checklist items</span>
                          </button>
                        </div>

                      </div> -->
                        <div class="text-sm content-end"
                             v-if="company.id in searchResult.associatedMetadata && 'attachments' in searchResult.associatedMetadata[company.id] && searchResult.associatedMetadata[company.id].attachments.length > 0"
                             :title="'This company has '+searchResult.associatedMetadata[company.id].attachments.length+' attachment(s)'">
<!--                          <button class="inline-flex items-center space-x-1 text-gray-500 mr-3"-->
<!--                             @click="$store.commit('addNotification', {title: 'See attachments', body: 'Not yet implemented', type:'warning' })">-->
<!--                            <PaperClipIcon class="flex-shrink-0 w-4 h-4" aria-hidden="true"/>-->
<!--                            <span class="font-medium text-gray-900" >{{ searchResult.associatedMetadata[company.id].attachments.length }}</span>-->
<!--                            <span class="sr-only">See the company attachments</span>-->
<!--                          </button>-->
                          <div class="inline-flex items-center space-x-1 text-gray-500 mr-3">
                            <PaperClipIcon class="flex-shrink-0 w-4 h-4" aria-hidden="true"/>
                            <span class="font-medium text-gray-900" >{{ searchResult.associatedMetadata[company.id].attachments.length }}</span>
                            <span class="sr-only">See the company attachments</span>
                          </div>

                        </div>


                      <!-- Rating -->
                      <div >
                        <div  v-if="company._metadata.score >= 0.01 && false"
                              class="flex flex-1 justify-end">
                          <StarIcon
                              v-for="rating in [0, 1, 2, 3, 4]" :key="rating"
                              :class="[company._metadata.score * 100 > rating ? 'text-yellow-400' : 'text-gray-200', 'h-5 w-5 flex-shrink-0']"
                              aria-hidden="true"/>
                        </div>

                        <!-- <div  v-if="upVvote + downVote > 0"
                              class="flex flex-1 justify-end mt-1">

                          <div class="inline-flex items-center text-sm" v-if="true">
                            <button class="inline-flex items-center space-x-1 text-gray-500 mr-3"
                                    @click="$store.commit('addNotification', {title: 'Up vote', body: 'Not yet implemented', type:'warning' })">
                              <ThumbUpIcon class="flex-shrink-0 w-4 h-4" aria-hidden="true"/>
                              <span class="font-medium text-gray-900">{{ upVvote }}</span>
                              <span class="sr-only">Up Vote</span>
                            </button>
                          </div>

                          <div class="inline-flex items-center text-sm" v-if="true">
                            <button class="inline-flex items-center space-x-1 text-gray-500 mr-3"
                                    @click="$store.commit('addNotification', {title: 'Down vote', body: 'Not yet implemented', type:'warning' })">
                              <ThumbDownIcon class="flex-shrink-0 w-4 h-4" aria-hidden="true"/>
                              <span class="font-medium text-gray-900">{{ downVote }}</span>
                              <span class="sr-only">Down Vote</span>
                            </button>
                          </div>

                          <StarIcon
                              v-for="rating in [0, 1, 2, 3, 4]" :key="rating"
                              :class="[ ratio * 5 > rating ? 'text-green-400' : 'text-gray-200', 'h-5 w-5 flex-shrink-0']"
                              aria-hidden="true"/>
                        </div>-->
                      </div>
                    </div>

                    <!--                    <h2 :id="'company-title-' + company.id" class="mt-4 text-base font-medium text-gray-900">-->
                    <!--                      {{ company.excerpt }}-->
                    <!--                    </h2>-->
                  </div>

                  <!-- Body -->
                  <div class="mt-2 space-y-4 text-gray-900 mt-3"
                       v-html="getCompanyDescription(company)"/>


                  <!-- Tags -->
                  <div class="mt-6" v-if="company.tags.length > 0">
                    <div class="flex">
                      <!--                      <h3 class="text-sm font-semibold tracking-wide text-gray-500">Tags</h3>-->
                      <TagIcon class="flex-shrink-0 w-5 h-5 text-gray-400" aria-hidden="true"/>

                      <!--                      <div aria-hidden="true" class="hidden w-px h-5 bg-gray-300 sm:block sm:ml-2" />-->

                      <div class="pl-1 mt-0 ml-1 border-l sm:ml-2 flex-shrink-1 sm:pl-2">
                        <div class="flex flex-wrap items-center -m-1">
                          <span v-for="tag in company.tags"
                                :key="company.id+'-'+tag.value"
                                :class="{ 'bg-primary-100': tagsReferential[tag.value] !== undefined && tagsReferential[tag.value].enable }"
                                class="inline-flex items-center pl-2 m-1 text-sm font-medium text-gray-900 bg-white rounded-full border border-primary-200"
                          >
                            <span class="lowercase">{{ tag.label }}</span>
                            <button type="button"
                                    v-if="tagsReferential[tag.value] !== undefined && ! tagsReferential[tag.value].enable"
                                    @click="useTag(tag.value, true); search(true)"
                                    class="inline-flex flex-shrink-0 p-1 ml-1 w-5 h-5 text-gray-400 rounded-full hover:bg-primary-200 hover:text-gray-500"
                                    title="Use this tag in your search">
                              <svg class="w-3 h-3" stroke="currentColor" fill="none" viewBox="0 0 20 20">
                                  <path stroke-width="1.5" fill-rule="evenodd"
                                        d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z"
                                        clip-rule="evenodd"/>
                              </svg>
                            </button>
                            <button type="button"
                                    v-if="tagsReferential[tag.value] !== undefined && tagsReferential[tag.value].enable"
                                    @click="useTag(tag.value, false); search(true)"
                                    class="inline-flex flex-shrink-0 justify-center items-center p-1 ml-1 w-5 h-5 text-gray-400 rounded-full hover:bg-primary-200 hover:text-gray-500"
                                    title="Click to remove this tag from your search">
                              <svg class="w-2 h-2" stroke="currentColor" fill="none" viewBox="0 0 8 8">
                                <path stroke-linecap="round" stroke-width="1.5" d="M1 1l6 6m0-6L1 7"/>
                              </svg>
                            </button>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>


                  <!-- Footer -->
                  <div class="flex justify-end mt-6 sm:justify-between sm:space-x-8">
                    <!-- Left Block -->
                    <div class="hidden space-x-6 sm:flex">
                      <div class="inline-flex items-center text-sm" v-if="company.address">
                        <div class="inline-flex items-center space-x-2 text-gray-400">
                          <LocationMarkerIcon class="flex-shrink-0 w-5 h-5" aria-hidden="true"/>
                          <span class="font-medium text-gray-900">{{ company.address }}</span>
                          <span class="sr-only">Address</span>
                        </div>
                      </div>
                      <div class="inline-flex items-center text-sm" v-if="company.employees && company.employees > 0">
                        <div class="inline-flex items-center space-x-2 text-gray-400">
                          <UserGroupIcon class="flex-shrink-0 w-5 h-5" aria-hidden="true"/>
                          <span class="font-medium text-gray-900" v-if="company.employees > 1">{{ company.employees }} employees</span>
                          <span class="font-medium text-gray-900" v-else>{{ company.employees }} employee</span>
                          <span class="sr-only">Size</span>
                        </div>
                      </div>
                    </div>
                    <!-- Right block -->
                    <div class="flex space-x-4 text-sm">
                      <span v-if="notRelevantCompanies.indexOf(company.id) === -1"
                            class="inline-flex items-center text-sm">
                        <button
                            v-if="relevantCompanies.indexOf(company.id) === -1"
                            class="inline-flex p-1 space-x-2 rounded-full border text-ternary hover:text-ternary-600 border-ternary hover:border-ternary-600 focus:outline-none focus:ring-1 focus:ring-ternary"
                            title="Mark as 'Interesting' for my search"
                            type="button"
                            @click="addRelevantCompanyToChannel($event, company)">
                          <HeartIcon class="w-6 h-6" aria-hidden="true"/>
                          <span class="sr-only">Relevant</span>
                        </button>
                        <button
                            v-else
                            class="inline-flex p-1 space-x-2 text-white rounded-full border bg-ternary border-ternary hover:bg-white hover:text-gray-600 hover:border-gray-600 focus:outline-none focus:ring-1 focus:ring-ternary"
                            title="Remove from my interesting list"
                            type="button"
                            @click="removeRelevantCompanyToChannel($event, company)">
                          <HeartIcon class="w-6 h-6" aria-hidden="true"/>
                          <span class="sr-only">Relevant</span>
                        </button>
                      </span>
                      <span v-if="relevantCompanies.indexOf(company.id) === -1"
                            class="inline-flex items-center text-sm">
                        <button
                            v-if="notRelevantCompanies.indexOf(company.id) === -1"
                            @click="addNotRelevantCompanyToChannel($event, company)"
                            type="button"
                            class="inline-flex p-1 space-x-2 text-gray-400 rounded-full border border-gray-400 hover:text-gray-600 hover:border-gray-600 focus:outline-none focus:ring-1 focus:gray-400"
                            title="Mark as 'Not Interesting' for my search">
                          <BanIcon class="w-6 h-6" aria-hidden="true"/>
                          <span class="sr-only">Not relevant</span>
                        </button>
                        <button
                            v-else
                            class="inline-flex p-1 space-x-2 text-white rounded-full border bg-gray-500 border-gray-500 hover:bg-white hover:text-gray-600 hover:border-gray-600 focus:outline-none focus:ring-1 focus:ring-ternary"
                            title="Mark as 'Neutral' for my search"
                            type="button"
                            @click="removeNotRelevantCompanyToChannel($event, company)">
                          <BanIcon class="w-6 h-6" aria-hidden="true"/>
                          <span class="sr-only">Not Relevant</span>
                        </button>
                      </span>
                      <span v-if="isInCustomCompanyChannel"
                            class="inline-flex items-center text-sm">
                        <button
                            @click="removeCompanyFromChannel($event, company)"
                            type="button"
                            class="inline-flex p-1 space-x-2 text-gray-400 rounded-full border border-gray-400 hover:text-red-600 hover:border-red-600 focus:outline-none focus:ring-1 focus:red-400"
                            title="Remove from the list">
                          <TrashIcon class="w-6 h-6" aria-hidden="true"/>
                          <span class="sr-only">Remove from the list</span>
                        </button>
                      </span>
                      <span class="inline-flex items-center text-sm">
                        <!-- Menu -->
                        <div class="flex flex-shrink-0 space-x-2">
                          <Menu as="div" class="inline-block relative text-left">
                            <div>
                              <MenuButton
                                  class="inline-flex p-1 text-gray-400 rounded-full border border-gray-400 hover:text-gray-600 hover:border-gray-600 focus:outline-none focus:ring-1 focus:gray-400"
                                  title="Additional actions">
                                <span class="sr-only">Open options</span>
                                <DotsHorizontalIcon class="w-6 h-6" aria-hidden="true"/>
                              </MenuButton>
                            </div>

                            <transition enter-active-class="transition duration-100 ease-out"
                                        enter-from-class="opacity-0 transform scale-95"
                                        enter-to-class="opacity-100 transform scale-100"
                                        leave-active-class="transition duration-75 ease-in"
                                        leave-from-class="opacity-100 transform scale-100"
                                        leave-to-class="opacity-0 transform scale-95">
                              <MenuItems class="absolute right-0 mt-2 w-56 bg-white rounded-md ring-1 ring-black ring-opacity-5 shadow-lg origin-top-right focus:outline-none divide-y divide-gray-200">
                                <div class="py-1">
                                  <MenuItem v-slot="{ active }" v-if="!isInRelevantChannel && !isInNotRelevantChannel">
                                    <button
                                        :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'flex px-4 py-2 text-sm w-full']"
                                        @click.stop="displaySaveToListDialog($event, company)"
                                        title="Save company in a list">
                                      <HeartIcon class="mr-3 w-5 h-5 text-gray-400" aria-hidden="true"/>
                                      <span>Save to list</span>
                                    </button>
                                  </MenuItem>

                                  <MenuItem v-slot="{ active }" v-if="!isInReportChannel">
                                    <button
                                        :set="countReports = companyReportsCount(company)"
                                        :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'flex px-4 py-2 text-sm w-full']"
                                        @click.stop="requestReportActionReport($event, company)"
                                        title="Request a detailed company report">
                                      <DownloadIcon class="mr-3 w-5 h-5 text-gray-400" aria-hidden="true"/>
                                      <span>Ask a report</span>
                                      <span v-show="countReports > 0" class="ml-3 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                                        {{ countReports }}
                                      </span>
                                    </button>
                                  </MenuItem>

                                  <MenuItem v-slot="{ active }" v-if="isSineroaUser">
                                    <button
                                        :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'flex px-4 py-2 text-sm w-full']"
                                        @click.stop="setCompanyForCopyCompanyPopup(company); setOpenCompanyCopyPopup(true);"
                                        title="Copy">
                                      <DocumentDuplicateIcon class="mr-3 w-5 h-5 text-gray-400" aria-hidden="true"/>
                                      <span>Copy</span>
                                    </button>
                                  </MenuItem>

<!--                                  <MenuItem v-slot="{ active }">-->
<!--                                    <button-->
<!--                                        :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'flex px-4 py-2 text-sm w-full']"-->
<!--                                        @click.stop="addToBenchmarkAction($event, company)"-->
<!--                                        title="Add the company to my benchmark list">-->
<!--                                      <PlusCircleIcon class="mr-3 w-5 h-5 text-gray-400" aria-hidden="true"/>-->
<!--                                      <span>Add to benchmarking</span>-->
<!--                                    </button>-->
<!--                                  </MenuItem>-->
                                </div>
                                <div class="py-1" v-if="isInCustomCompanyChannel">
<!--                                  <MenuItem v-slot="{ active }">-->
<!--                                    <button-->
<!--                                        :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'flex px-4 py-2 text-sm w-full']"-->
<!--                                        @click.stop="removeCompanyAction($event, company)">-->
<!--                                      <TrashIcon class="mr-3 w-5 h-5 text-red-500" aria-hidden="true"/>-->
<!--                                      <span>Remove</span>-->
<!--                                    </button>-->
<!--                                  </MenuItem>-->
                                  <MenuItem v-slot="{ active }" >
                                    <button
                                        :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'flex px-4 py-2 text-sm w-full']"
                                        @click.stop="removeCompanyFromChannel($event, company)"
                                        title="Remove from the list">
                                      <TrashIcon class="mr-3 w-5 h-5 text-gray-400 text-red-500" aria-hidden="true"/>
                                      <span>Remove from the list</span>
                                    </button>
                                  </MenuItem>
                                </div>
                              </MenuItems>
                            </transition>
                          </Menu>
                        </div>
                      </span>

                      <span class="inline-flex items-center text-sm">
                        <button
                            @click="startupPopup($event, company, true)"
                            type="button"
                            title="View more information about it"
                            class="flex justify-center items-center px-4 py-1 w-full text-base font-medium text-white rounded-md border border-transparent bg-ternary-500 hover:bg-ternary-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-50 focus:ring-ternary-500">
                          Detail
                        </button>
                      </span>
                    </div>
                    <!-- Footer End-->
                  </div>

                </article>
              </li>

            </ul>

            <paginate v-if="searchResult._metadata !== undefined && searchResult._metadata.total > 0"
                      :page="searchResult._metadata.page - 1"
                      :items-per-page="searchResult._metadata.limit"
                      :max-visible-pages="3"
                      :total-items="searchResult._metadata.total"
                      @page-change="pageChange($event)"
            ></paginate>

          </div>
        </main>

<!--
        <aside class="hidden filter blur xl:block xl:col-span-3">
          <div class="sticky top-4 space-y-4">
            <section aria-labelledby="who-to-follow-heading">
              <div class="bg-white rounded-lg shadow">
                <div class="p-6">
                  <h2 id="who-to-follow-heading" class="text-base font-medium text-gray-900">
                    Who to follow
                  </h2>
                  <div class="flow-root mt-6">
                    <ul role="list" class="-my-4 divide-y divide-gray-200">
                      <li v-for="user in whoToFollow" :key="user.handle" class="flex items-center py-4 space-x-3">
                        <div class="flex-shrink-0">
                          <img class="w-8 h-8 rounded-full" :src="user.imageUrl" alt=""/>
                        </div>
                        <div class="flex-1 min-w-0">
                          <p class="text-sm font-medium text-gray-900">
                            <a :href="user.href">{{ user.name }}</a>
                          </p>
                          <p class="text-sm text-gray-500">
                            <a :href="user.href">{{ '@' + user.handle }}</a>
                          </p>
                        </div>
                        <div class="flex-shrink-0">
                          <button type="button"
                                  class="inline-flex items-center px-3 py-0.5 rounded-full bg-primary bg-opacity-10 text-sm font-medium text-primary-dark hover:bg-primary hover:bg-opacity-20">
                            <PlusSmIcon class="-ml-1 mr-0.5 h-5 w-5 text-primary" aria-hidden="true"/>
                            <span>
                              Follow
                            </span>
                          </button>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div class="mt-6">
                    <a href=""
                       class="block px-4 py-2 w-full text-sm font-medium text-center text-gray-700 bg-white rounded-md border border-gray-300 shadow-sm hover:bg-gray-50">
                      View all
                    </a>
                  </div>
                </div>
              </div>
            </section>
            <section aria-labelledby="trending-heading">
              <div class="bg-white rounded-lg shadow">
                <div class="p-6">
                  <h2 id="trending-heading" class="text-base font-medium text-gray-900">
                    Trending
                  </h2>
                  <div class="flow-root mt-6">
                    <ul role="list" class="-my-4 divide-y divide-gray-200">
                      <li v-for="post in trendingPosts" :key="post.id" class="flex py-4 space-x-3">
                        <div class="flex-shrink-0">
                          <img class="w-8 h-8 rounded-full" :src="post.user.imageUrl" :alt="post.user.name"/>
                        </div>
                        <div class="flex-1 min-w-0">
                          <p class="text-sm text-gray-800">{{ post.body }}</p>
                          <div class="flex mt-2">
                            <span class="inline-flex items-center text-sm">
                              <button type="button" class="inline-flex space-x-2 text-gray-400 hover:text-gray-500">
                                <ChatAltIcon class="w-5 h-5" aria-hidden="true"/>
                                <span class="font-medium text-gray-900">{{ post.comments }}</span>
                              </button>
                            </span>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div class="mt-6">
                    <a href=""
                       class="block px-4 py-2 w-full text-sm font-medium text-center text-gray-700 bg-white rounded-md border border-gray-300 shadow-sm hover:bg-gray-50">
                      View all
                    </a>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </aside>
-->


      </div>
    </div>


    <company-content
        @display-save-to-list-dialog="displaySaveToListDialog($event, $event.company)"
        @request-report-action-report="requestReportActionReport($event, $event.company)"
        @add-to-benchmark-action="addToBenchmarkAction($event, $event.company)"
        @remove-company-from-channel="removeCompanyFromChannel($event, $event.company)"
        @use-tag="useTag($event.tag, $event.use); search(true);"

        @attachments:add="attachment => addAttachment(attachment)"
        @attachments:remove="attachment => removeAttachment(attachment)"

        @close="showSponsorshipPopupopenCompanyPopupDetail = false; startupPopup($event, undefined, false)"
        :open="openCompanyPopupDetail"
        :company="companyPopupDetail"
        :tagsReferential="tagsReferential"
    ></company-content>

    <sponsorship-form
        :open="showSponsorshipPopup"
        @close="setOpenSponsorshipPopup(false); setWorkspaceForSponsorshipPopup(null)"
    ></sponsorship-form>

    <workspace-copy-form
        v-if="showWorkspaceCopyPopup"
        :open="showWorkspaceCopyPopup"
        @close="setOpenCopyWorkspacePopup(false); setWorkspaceForCopyWorkspacePopup(null)"
    ></workspace-copy-form>

    <company-copy-form
        v-if="showCompanyCopyPopup"
        :open="showCompanyCopyPopup"
        @close="setOpenCompanyCopyPopup(false); setCompanyForCopyCompanyPopup(null)"
    ></company-copy-form>

    <ui-notification v-if="notifications.length > 0"></ui-notification>

    <save-to-list
        v-if="openSaveToListDialog"
        :company="companyToSave"
        :open="openSaveToListDialog"
        @close="openSaveToListDialog = false"
    >
    </save-to-list>

    <innovation-project
        v-if="openInnovationProjectEditor"
        @create-innovation-project="handleInnovationProjectCreation()"
        @close="openInnovationProjectEditor=false"
        :open="openInnovationProjectEditor"
        :workspace="editInnovationProject"
    ></innovation-project>

    <simple-reject-company-dialog
        v-if="openRejectCompanyDialog"
        @close="openRejectCompanyDialog=false"
        :open="openRejectCompanyDialog"
        :company="companyToReject"
        :channelUuid="getChannelUuid(currentViewChannel)"
        :not-relevant-channel-uuid="notRelevantCompaniesChannelUuid"
    >
    </simple-reject-company-dialog>

    <main-notifications-panel
        v-if="openNotificationCenter"
        @close="openNotificationCenter=false"
        :open="openNotificationCenter"
    >
    </main-notifications-panel>
  </div>
</template>

<script>
import _debounce from 'lodash.debounce'

import ActionButtonNav from "@/components/Navigation/ActionButtonNav";
import ItemNav from "@/components/Navigation/ItemNav";
import ComplexItemNav from "@/components/Navigation/ComplexItemNav";
import SectionNav from "@/components/Navigation/SectionNav";

import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
  Popover,
  PopoverButton,
  PopoverPanel,
  TransitionChild,
  TransitionRoot,
  Dialog,
  DialogPanel
} from '@headlessui/vue'
import {
  BanIcon,
  ChevronDownIcon,
  CodeIcon,
  DotsHorizontalIcon,
  DownloadIcon,
  ExternalLinkIcon,
  EyeIcon,
  FilterIcon,
  FlagIcon,
  HeartIcon,
  LocationMarkerIcon,
  PlusSmIcon,
  SearchIcon,
  ShareIcon,
  SortAscendingIcon,
  StarIcon,
  TagIcon,
  UserGroupIcon,
} from '@heroicons/vue/solid'
import {
  ArchiveIcon,
  BellIcon,
  CalendarIcon,
  ChatAltIcon,
  DocumentDuplicateIcon,
  DocumentIcon,
  DocumentReportIcon,
  DocumentSearchIcon,
  HomeIcon,
  MenuIcon,
  OfficeBuildingIcon,
  PaperClipIcon,
  PencilAltIcon,
  PencilIcon,
  PlusCircleIcon,
  PlusIcon,
  PresentationChartBarIcon,
  PresentationChartLineIcon,
  ThumbDownIcon,
  ThumbUpIcon,
  TrashIcon,
  UserAddIcon,
  XIcon,
  PaperAirplaneIcon
} from '@heroicons/vue/outline'
import Paginate from "@/components/Navigation/Paginate";
import CompanyContent from "@/components/ContentCard/CompanyContent";
import SimpleLoader from "@/components/SimpleLoader";
import SponsorshipForm from "@/components/Sponsorship/SponsorshipForm";
import {mapGetters, mapMutations, mapState} from "vuex";
import _isUndefined from "lodash/isUndefined";
import UiNotification from "@/components/Notification/uiNotification";
import _get from "lodash/get";
import _isString from "lodash/isString";
import SaveToList from "@/components/SaveToList";
import InnovationProject from "@/components/InnovationProject";
import SimpleRejectCompanyDialog from "@/components/Polling/SimpleRejectCompanyDialog";
import MainNotificationsPanel from "@/components/SidePanel/MainNotificationsPanel";
import WorkspaceCopyForm from "@/components/Forms/WorkspaceCopyForm";
import CompanyCopyForm from "@/components/Forms/CompanyCopyForm";

const user = {
  name: 'Chelsea Hagon',
  email: 'chelseahagon@example.com',
  imageUrl:
      'https://images.unsplash.com/photo-1550525811-e5869dd03032?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
}
const navigation = [
  {name: 'Home', href: '#', icon: HomeIcon, count: undefined, current: false},
  // { name: 'Popular', href: '#', icon: FireIcon, count: 3, current: false },
  // { name: 'Communities', href: '#', icon: UserGroupIcon, count: 54, current: false },
  // { name: 'Trending', href: '#', icon: TrendingUpIcon, count: 38, current: false },
  {
    name: 'Workspaces',
    icon: undefined,
    section: 'dynamic',
    current: false,
    count: undefined,
    externalWrapperClass: 'py-2 border-t border-b border-past-blue-light',
    children: [
      {name: 'New', href: '#', icon: PlusIcon, type: 'button'},
      {
        name: 'Default workspace',
        icon: DocumentReportIcon,
        href: undefined,
        actions: [
          {name: 'Rename', href: '#', icon: PencilIcon},
          {name: 'Edit', href: '#', icon: PencilAltIcon},
          {name: 'Duplicate', href: '#', icon: DocumentDuplicateIcon},
          {name: 'Archive', href: '#', icon: ArchiveIcon},
          {name: 'Delete', href: '#', icon: XIcon, iconClass: 'text-red-500'},
        ]
      },
      {
        name: 'Another workspace',
        href: undefined,
        icon: DocumentReportIcon,
        actions: [
          {name: 'Rename', href: '#', icon: PencilIcon},
          {name: 'Edit', href: '#', icon: PencilAltIcon},
          {name: 'Duplicate', href: '#', icon: DocumentDuplicateIcon},
          {name: 'Archive', href: '#', icon: ArchiveIcon},
          {name: 'Delete', href: '#', icon: XIcon, iconClass: 'text-red-500'},
        ]
      },
    ],
    actions: undefined
  },
  {
    name: 'Current Workspace',
    icon: HomeIcon,
    section: 'static',
    current: false,
    count: undefined,
    externalWrapperClass: 'py-2 border-b border-gray-300',
    children: [
      {
        name: 'Recommendations',
        href: '#',
        icon: EyeIcon,
        type: 'button',
        onClickCallback: function (component) {
          component.$store.commit('setDisplayRecommendations', true)
        }
      },
      {
        name: 'Search',
        href: '#',
        icon: SearchIcon,
        type: 'button',
        onClickCallback: function (component) {
          component.$store.commit('setDisplaySearchResult', true)
        }
      },
      {
        name: 'Invite',
        href: '#',
        icon: UserAddIcon,
        type: 'button',
        onClickCallback: function (component) {
          component.$store.commit('setOpenSponsorshipPopup', true)
        }
      },
      {
        name: 'Assessments',
        icon: PresentationChartLineIcon,
        href: undefined,
        count: "6/7",
        children: [
          {name: 'All', href: '#', icon: undefined, count: "6/7"},
          {name: 'Reports', href: '#', icon: undefined, count: "3/4"},
          {name: 'Benchmarks', href: '#', icon: undefined, count: "3/3"},
        ],
        actions: undefined
      },
      {
        name: 'Companies',
        href: undefined,
        icon: OfficeBuildingIcon,
        count: "12/3",
        current: true,
        children: [
          {name: 'Data Management Platform', href: '#', icon: undefined, count: "6", current: true},
          {name: 'Marketing platform automation', href: '#', icon: undefined, count: "3", current: false,},
          {name: 'Customer engagement', href: '#', icon: undefined, count: "3"},
        ],
      },
      // {
      //   name: 'My Documents',
      //   href: undefined,
      //   icon: DocumentIcon,
      //   count: "6"
      // },
      // {
      //   name: 'Curated Topics',
      //   href: undefined,
      //   icon: PresentationChartBarIcon,
      //   count: "3",
      //   children: [
      //     { name: 'Marketing automation', href: '#', icon: undefined },
      //     { name: 'Hydrogen catalyst', href: '#', icon: undefined },
      //     { name: 'Artificial Intelligence', href: '#', icon: undefined },
      //   ],
      // },
      // {
      //   name: 'Search history',
      //   href: undefined,
      //   icon: DocumentSearchIcon,
      //   count: "562"
      // },
    ],
    actions: undefined
  },
  // {
  //   name: 'Team',
  //   icon: UsersIcon,
  //   section: undefined,
  //   current: false,
  //   count: 8,
  //   children: [
  //     { name: 'Overview', href: '#' },
  //     { name: 'Members', href: '#' },
  //     { name: 'Calendar', href: '#' },
  //     { name: 'Settings', href: '#' },
  //   ],
  //   actions: [
  //     { name: 'Rename', href: '#', icon: PencilIcon },
  //     { name: 'Edit', href: '#', icon: PencilAltIcon },
  //     { name: 'Duplicate', href: '#', icon: DocumentDuplicateIcon },
  //     { name: 'Archive', href: '#', icon: ArchiveIcon },
  //     { name: 'Delete', href: '#', icon: XIcon, iconClass: 'text-red-500' },
  //   ]
  // },
  // { name: 'New', href: '#', icon: TrendingUpIcon, type: 'button' },
]
const userNavigation = [
  // {name: 'Your Profile', onClickCallback: function(component) { component.editProfile()}},
  // {name: 'Settings', onClickCallback: function(component) { component.editSettings()}},
  {name: 'Sign out', onClickCallback: function(component) { component.$store.dispatch("logout"); component.$router.push('/login')}},
]

// const workspaces = [
//   { name: 'Default workspace', href: '#' },
//   { name: 'My second workspace', href: '#' },
// ]
const tabs = [
  {name: 'Search Result', href: '#', current: true},
  {name: 'Recommendations', href: '#', current: false},
  // { name: 'Most Answers', href: '#', current: false },
]

const whoToFollow = [
  {
    name: 'Leonard Krasner',
    handle: 'leonardkrasner',
    href: '#',
    imageUrl:
        'https://images.unsplash.com/photo-1519345182560-3f2917c472ef?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  },
  // More people...
]
const trendingPosts = [
  {
    id: 1,
    user: {
      name: 'Floyd Miles',
      imageUrl:
          'https://images.unsplash.com/photo-1463453091185-61582044d556?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    },
    body: 'What books do you have on your bookshelf just to look smarter than you actually are?',
    comments: 291,
  },
  // More posts...
]


const defaultFilters = {
  tag: {
    label: 'Tag',
    options: []
  },
  location: {
    label: 'Location',
    options: []
  },
  size: {
    label: 'Size',
    options: []
  },
  age: {
    label: 'Age',
    options: []
  },
}

const sortOptions = [
  {name: 'Most relevant', value: {'sortBy': 'relevance', 'sortDirection': 'DESC'}, current: true},
  {name: 'Newest', value: {'sortBy': 'date', 'sortDirection': 'DESC'}, current: false},
  // { name: 'Best Rating', value: '', href: '#', current: false },
]


export default {
  components: {
    CompanyCopyForm,
    WorkspaceCopyForm,
    MainNotificationsPanel,
    SimpleRejectCompanyDialog,
    InnovationProject,
    SaveToList,
    UiNotification,
    SponsorshipForm,
    SimpleLoader,
    CompanyContent,
    Paginate,
    SectionNav,
    ComplexItemNav,
    ItemNav,
    ActionButtonNav,
    Menu,
    MenuButton,
    MenuItem,
    MenuItems,
    Popover,
    PopoverButton,
    PopoverPanel,
    BellIcon,
    ChatAltIcon,
    CodeIcon,
    // DotsVerticalIcon,
    DotsHorizontalIcon,
    DocumentDuplicateIcon,
    DownloadIcon,
    EyeIcon,
    FlagIcon,
    MenuIcon,
    PlusSmIcon,
    SearchIcon,
    ShareIcon,
    StarIcon,
    ThumbUpIcon,
    ThumbDownIcon,
    HeartIcon,
    BanIcon,
    ChevronDownIcon,
    FilterIcon,
    XIcon,
    TagIcon,
    CalendarIcon,
    ExternalLinkIcon,
    LocationMarkerIcon,
    UserGroupIcon,
    Disclosure,
    DisclosureButton,
    DisclosurePanel,
    TrashIcon,
    PlusCircleIcon,
    DocumentIcon,
    DocumentSearchIcon,
    PresentationChartBarIcon,
    PaperClipIcon,
    SortAscendingIcon,
    TransitionChild,
    TransitionRoot,
    Dialog,
    DialogPanel,
    PaperAirplaneIcon
  },
  setup() {
    return {
      user,
      // navigation,
      userNavigation,
      // workspaces,
      tabs,
      whoToFollow,
      trendingPosts,
      sortOptions,
    }
  },

  data() {
    return {

      blockUI: false,
      sidebarOpen: false,

      workspacesNavigation: {},


      searchTerms: undefined,
      searchResult: {},
      searchPage: 1,
      searchLimit: 15,
      searchSort: {'sortBy': 'relevance', 'sortDirection': 'DESC'},

      filters: {},
      selectedFilters: {},
      countSelectedFilters: 0,
      iTagSearchValue: undefined,
      iFilteredTags: [],


      tagsReferential: {
        'tag-name': {
          'src': 'filter|company|search-bar',
          'enable': true,
          'location': 'filter|company',
          'ref': {
            'label': '',
            'value': '',
            'checked': '',
          }
        }
      },


      openCompanyPopupDetail: false,
      companyPopupDetail: undefined,

      openSaveToListDialog: false,
      companyToSave: null,

      openInnovationProjectEditor: false,
      editInnovationProject: null,

      openRejectCompanyDialog: false,
      companyToReject: null,

      openNotificationCenter: false,

      _searchTimer: null,
      _headerHeight: 70
    }
  },
  created() {
    this.$store.dispatch('retrieveGlobalNotifications', {});

    this._filters().then(function () {
      this.useInnovationProjectTags();
    }.bind(this));

    this.initializeWorkspace();

    this.$nextTick(function () {
      setTimeout(function() {
        const headerHeight = this.$refs['main-header'].offsetHeight;
        if(headerHeight < 150) {
          this._headerHeight = headerHeight;
        }
      }.bind(this), 500);
    }.bind(this));
  },

  mounted() {
    this.$refs['search-bar'].addEventListener('search', (e) => this.searchTimeout());
  },

  methods: {
    log(value) {
      console.log(value)
    },

    setSearchSort(sortOption) {
      this.sortOptions = this.sortOptions.map(option => {
        if (option.name !== sortOption.name) {
          option.current = false;
        } else {
          option.current = true;
        }

        return option;
      });

      this.searchSort = sortOption.value;
    },

    searchTimeout() {
      if (this._searchTimer) {
        clearTimeout(this._searchTimer);
        this._searchTimer = null;
      }
      this._searchTimer = setTimeout(() => {
        this.search(true);
      }, 500);

    },

    search: _debounce(function (newSearch, searchDataOverride = null) {
      if (this.blockUI) {
        return;
      } else {
        this.blockUI = true;
      }

      if(searchDataOverride === null && this.currentViewChannel !== null) {
        this.$store.commit('setCurrentViewChannel', null);
      }

      if (newSearch === true) {
        this.searchPage = 1;
      }

      if (this.searchTerms === undefined) {
        this.searchTerms = '';
      }

      let formData = new FormData();
      if (searchDataOverride === null) {
        formData.append('query', this.searchTerms);
        formData.append('limit', this.searchLimit);
        formData.append('page', this.searchPage);

        if (this.searchSort !== null) {
          formData.append('sortBy', this.searchSort.sortBy);
          formData.append('sortDirection', this.searchSort.sortDirection);
        }

        Object.keys(this.selectedFilters).forEach(item => {
          let selectedFilters = Object.keys(this.selectedFilters[item]);
          if (selectedFilters.length > 0) {
            selectedFilters.forEach(value => {
              formData.append(item + '[]', value);
            });
          }
        });
      } else {
        // Cas des recherches exactes
        searchDataOverride.slugs.map(n => formData.append('slug[]', n));
        formData.append('limit', searchDataOverride.slugs.length);

        if(searchDataOverride.slugs.length === 0) {
          this.searchResult = {recordset: [], _metadata: {"total":0,"pages":0,"limit":1,"page":1,"searchTerm":""}};
          this.blockUI = false;

          return;
        }
      }

      const searchResult = this.$axios
          .post(this.$apiUrl + '/search', formData, {})
          .then(async function (response) {
            let localSearchResult = response.data;


            // Set tag in the referential
            let companies = [];
            localSearchResult.recordset.forEach(function (company) {
              companies[company.id] = company.id;
              if (company.tags.length > 0) {
                company.tags.forEach(function (tag) {
                  if (typeof this.tagsReferential[tag.value] === 'undefined') {
                    this.tagsReferential[tag.value] = {
                      'src': 'company',
                      'enable': tag.checked ? tag.checked : false,
                      'location': [],
                      'label': tag.label,
                    }
                  }

                  const referentTag = this.tagsReferential[tag.value];
                  referentTag.enable = (tag.checked ? tag.checked : false) || referentTag.enable;
                  if (referentTag.location.indexOf('company') === -1) {
                    referentTag.location.push('company')
                  }

                }.bind(this));
              }
            }.bind(this));


            localSearchResult.associatedMetadata = {};
            await this.$store.dispatch('loadAttachments', {
              companies: Object.keys(companies),
            }).then(function (attachments) {
              localSearchResult.associatedMetadata = {};
              for (const attachment of attachments) {
                if(! (attachment.companySlug in localSearchResult.associatedMetadata)) {
                  localSearchResult.associatedMetadata[attachment.companySlug] = {attachments: []};
                }
                localSearchResult.associatedMetadata[attachment.companySlug]['attachments'].push(attachment);
              }
            }.bind(this));

            this.searchResult = localSearchResult;
            this.blockUI = false;

          }.bind(this)).catch(function (error) {
            // console.log(error)
            this.blockUI = false;
            this.searchResult = {};
            throw error;
          }.bind(this));

    }, 300, {'maxWait': 1000}),

    async initializeWorkspace() {
      const currentWorkspaceSlug = this.currentWorkspaceSlug;
      if (currentWorkspaceSlug) {
        this.$store.dispatch('getUserWorkspaces');
      } else {
        await this.$store.dispatch('getUserWorkspaces');
      }
      this.$store
          .dispatch('getCurrentWorkspace', this.currentWorkspaceSlug)
          .then(function () {
            this.useInnovationProjectTags();
            this.search(true);
          }.bind(this));
    },

    pageChange(payload) {
      this.searchPage = parseInt(payload.page) + 1;
      this.search(false);
    },

    selectFiltersOption(filterName, optionValue, isSelected) {
      if (typeof filterName !== "string" || typeof optionValue !== "string" || typeof isSelected !== "boolean") {
        return false;
      }

      if(filterName === 'tag' && !this.tagsReferential[optionValue]){
        // console.log(`Tags ${optionValue} not found in the referential`);
        return false;
      }
      // const checked = ! this.filters[filterName]['options'][index]['checked'];

      if (isSelected) {
        this.countSelectedFilters++;
        this.selectedFilters[filterName][optionValue] = true;
        // this.selectedFilters[filterName][this.filters[filterName]['options'][index]['value']] = true;
      } else {
        this.countSelectedFilters--;
        delete this.selectedFilters[filterName][optionValue]
        // delete this.selectedFilters[filterName][this.filters[filterName]['options'][index]['value']]
      }

      return true;
      // this.filters[filterName]['options'][index]['checked'] =  checked;
    },


    useTag(tagValue, enable = false) {
      if (typeof tagValue === 'string' && tagValue.length > 0) {

        // Mise à jour du référentiel des tags
        // Le référentiel possède tous les tags disponible dans l'application front
        if(! this.tagsReferential[tagValue]){
          // console.log(`Tags ${tagValue} not found in the referential`);
          return;
        }

        this.tagsReferential[tagValue].enable = enable;

        // Mise à jour de l'input dans le filtre tag
        // Le filtre peut ne pas avoir le tag, il faut l'ajouter si nécessaire
        const tagIndex = this.filters.tag.options.findIndex(option => tagValue === option.value);
        if (tagIndex !== -1) {
          this.filters.tag.options[tagIndex].checked = enable;
        } else {
          this.filters.tag.options.push({
            'label': this.tagsReferential[tagValue].label,
            'value': tagValue,
            'checked': this.tagsReferential[tagValue].enable,
          });
        }

        // Mise à jour dans les filtres selectionnées pour réaliser la recherche
        if (this.selectedFilters['tag'][tagValue] !== enable) {
          if (enable) {
            this.countSelectedFilters++;
            this.selectedFilters['tag'][tagValue] = true;
          } else {
            this.countSelectedFilters--;
            delete this.selectedFilters['tag'][tagValue];
          }
        }

        this._filterTags();
      }
    },

    clearSearch() {
      this.searchTerms = undefined;
    },

    clearFilters(event, filterName) {
      let filtersKeys = [filterName.toLowerCase()];
      if (typeof filterName !== "string" || filterName.toLowerCase() === 'all') {
        filtersKeys = Object.keys(this.filters);
      }

      let countSelectedFilters = this.countSelectedFilters;
      let hasChange = false;
      filtersKeys.forEach(item => {
        this.filters[item]['options'].map(filter => {
          if (filter.checked) {
            hasChange = true;
            filter.checked = false;
            countSelectedFilters--;
            if (item === 'tag') {
              this.useTag(filter.value, false);
            }
          }
        })
        this.selectedFilters[item] = {};
      });

      if (filterName.toLowerCase() === 'tag' || filterName.toLowerCase() === 'all') {
        this._filterTags();
      }

      this.countSelectedFilters = countSelectedFilters;
      if (this.countSelectedFilters === 0) {
        this.useInnovationProjectTags();
        this.search(true);
        return;
      }

      if (hasChange) {
        this.search(false);
      }
    },

    displaySaveToListDialog(event, company) {
      // console.log(event)
      this.openSaveToListDialog = true;
      this.companyToSave = company;
    },


    removeCompanyFromChannel($event, company) {
      this.$store.dispatch('removeCompanyFromChannel', {
        company: company,
        channelUuid: this.getChannelUuid(this.currentViewChannel)
      }).then(function() {

        this.search(true, {
          slugs: this.getChannelCompanies(this.currentViewChannel)
        });

        // this.removeRelevantCompanyToChannel($event, company);
      }.bind(this));
    },

    addRelevantCompanyToChannel(event, company) {
      this.$store.dispatch('addCompanyToChannel', {company: company, channelUuid: this.relevantCompaniesChannelUuid})
    },
    removeRelevantCompanyToChannel(event, company) {
      this.$store.dispatch('removeCompanyFromChannel', {
        company: company,
        channelUuid: this.relevantCompaniesChannelUuid
      })
    },
    addNotRelevantCompanyToChannel(event, company) {
      this.openRejectCompanyDialog = true;
      this.companyToReject = company;
      // this.$store.dispatch('addCompanyToChannel', {company: company, channelUuid: this.notRelevantCompaniesChannelUuid})
    },
    removeNotRelevantCompanyToChannel(event, company) {
      this.$store.dispatch('removeCompanyFromChannel', {
        company: company,
        channelUuid: this.notRelevantCompaniesChannelUuid
      })
    },

    startupPopup(event, company, open) {
      if (typeof open !== 'boolean') {
        return;
      }

      if (open) {
        this.companyPopupDetail = company;
      }

      this.openCompanyPopupDetail = open;
    },


    // removeCompanyAction(event, company) {
    //   // TODO: Need to implement the feature
    //   this.$store.commit('addNotification', {
    //     title: 'TODO',
    //     body: 'Not yet implemented',
    //     type: 'warning',
    //   })
    // },

    requestReportActionReport(event, company) {
      this.$store.dispatch('createReport', {
        company: company,
        innovation: this.currentInnovation,
        channelUuid: this.companyReportsChannelUuid
      })
    },

    addToBenchmarkAction(event, company) {
      // TODO: Need to implement the feature
      this.$store.commit('addNotification', {
        title: 'TODO',
        body: 'Not yet implemented',
        type: 'warning',
      })
    },

    handleInnovationProjectCreation() {
      // console.log(this.currentWorkspace)
      // console.log(this.currentWorkspace.innovationProject)
      this.clearFilters(null, 'all');
      // this.useInnovationProjectTags();
      // this.search(true);
    },

    switchToAnotherWorkspace(workspaceSlug) {
      return this.$store.dispatch('getCurrentWorkspace', workspaceSlug)
          .then(function () {
            this.$store.commit('setCurrentViewChannel', null);

            this.clearSearch();
            this.clearFilters(null, 'all');

            // this.useInnovationProjectTags();
            // this.search(true);

            this.$store.commit("addNotification", {
              title: 'Switch to "' + this.$store.getters.getCurrentWorkspaceName + '"',
              body: null,
              type: 'info',
            })

            //TODO: Recharger la dernière recherhce de l'utilisateur de ce workspace
          }.bind(this));
    },

    useInnovationProjectTags() {
      if (this.currentWorkspace && this.currentWorkspace.innovationProject !== null) {
        for (const tag of this.currentWorkspace.innovationProject.tags) {
          let normalizedTag = 't_' + tag.toLowerCase().replace(' ', '_');
          if (!this.tagsReferential[normalizedTag]) {
            normalizedTag = 'a' + normalizedTag.substring(1);
          }
          if (this.tagsReferential[normalizedTag]) {
            this.selectFiltersOption('tag', normalizedTag, true);
            this.useTag(normalizedTag, true);
          }
        }
      }
    },

    _filters() {
      return this.$axios
          .get(this.$apiUrl + '/search-filters')
          .then(function (response) {
            let filters = response.data;
            this.countSelectedFilters = 0;
            this.selectedFilters = {};
            this.tagsReferential = {};

            Object.keys(filters).forEach(function (item) {
              this.selectedFilters[item] = {}

              if (filters[item]['options'] == null) {
                filters[item]['options'] = defaultFilters[item]['options'];
              }

              // this.selectedFilters[item] = {};
              // this.countSelectedFilters += filters[item]['options'].filter(filter => filter.checked === true).length
              // Identification des filtres actifs
              filters[item]['options'].forEach(function (option) {
                if (option.checked) {
                  this.countSelectedFilters++;
                  this.selectedFilters[item][option.value] = true;
                }
              }.bind(this));

              // Trie des filtres alphabétiques
              if (item !== 'age' && item !== 'size') {
                filters[item]['options'].sort(function (a, b) {
                  return a.label.localeCompare(b.label);
                });
              }
            }.bind(this));

            // Set tag in the referential
            if (typeof filters.tag !== 'undefined') {
              filters.tag.options.forEach(function (tag) {
                if (typeof this.tagsReferential[tag.value] === 'undefined') {
                  this.tagsReferential[tag.value] = {
                    'src': 'filter',
                    'enable': tag.checked ? tag.checked : false,
                    'location': [],
                    'label': tag.label,
                  }
                }

                this.tagsReferential[tag.value].enable = (tag.checked ? tag.checked : false) || this.tagsReferential[tag.value].enable;
                if (this.tagsReferential[tag.value].location.indexOf('filter') === -1) {
                  this.tagsReferential[tag.value].location.push('filter');
                }
              }.bind(this));
            }

            this.filters = filters;
            this._filterTags();

          }.bind(this))
          .catch(function (error) {
            // TODO: Make error management
            console.log(error)
            throw error
          });
    },

    _filterTags() {
      let reg = undefined;
      if (this.iTagSearchValue === undefined) {
        reg = new RegExp('.*', 'i');
      } else {
        reg = new RegExp('.*' + this.iTagSearchValue + '.*', 'i');
      }

      // this.iFilteredTags = this.filters.tag.options.filter(tag => tag.label.match(reg));
      let selectedFilteredTags = [];
      let filteredTags = [];
      for (let i = 0, max = this.filters.tag.options.length; i < max; i++) {
        if (this.filters.tag.options[i].label.match(reg)) {
          let tag = this.filters.tag.options[i];
          tag.originalIdx = i;
          if(tag.checked) {
            selectedFilteredTags.push(tag);
          } else {
            filteredTags.push(tag);
          }
        }
      }

      this.iFilteredTags = selectedFilteredTags.concat(filteredTags);
    },


    companyReportsCount(company) {
      let indexes = [];
      for(let i = 0; i < this.reports.length; i++) {
        if (this.reports[i].companyId === company.id) {
          indexes.push(i);
        }
      }

      return indexes.length;
    },

    ...mapMutations([
      'setOpenSponsorshipPopup',
      'setWorkspaceForSponsorshipPopup',
      'setOpenCopyWorkspacePopup',
      'setWorkspaceForCopyWorkspacePopup',
      'setOpenCompanyCopyPopup',
      'setCompanyForCopyCompanyPopup'
    ]),


    editProfile(event) {
      // TODO: Need to implement the feature
      this.$store.commit('addNotification', {
        title: 'TODO',
        body: 'Not yet implemented',
        type: 'warning',
      })
    },

    editSettings(event) {
      // TODO: Need to implement the feature
      this.$store.commit('addNotification', {
        title: 'TODO',
        body: 'Not yet implemented',
        type: 'warning',
      })
    },

    getCompanyDescription(company) {
      if(_isString(company.excerpt) && company.excerpt.length) {
        return company.excerpt;
      }
      if(_isString(company.description_short) && company.description_short.length) {
        return company.description_short;
      }
      if(_isString(company.description) && company.description.length) {
        return company.description;
      }

      return 'No description available.';
    },

    ...mapGetters({
      getCurrentMemberProfile: 'getCurrentMemberProfile',
    }),

    addAttachment(attachment) {
      if (!(attachment.companySlug in this.searchResult.associatedMetadata)) {
        this.searchResult.associatedMetadata[attachment.companySlug] = {'attachments': []}
      }
      this.searchResult.associatedMetadata[attachment.companySlug].attachments.push(attachment);

      this.$forceUpdate();
    },
    removeAttachment(attachment) {
      if (attachment.companySlug in this.searchResult.associatedMetadata) {
        this.searchResult.associatedMetadata[attachment.companySlug].attachments = this.searchResult.associatedMetadata[attachment.companySlug].attachments.filter(lattachment => lattachment.uuid !== attachment.uuid)
        this.$forceUpdate();
      }
    }
  },

  watch: {
    iTagSearchValue() {
      this._filterTags();
    }
  },

  computed: {
    isSineroaUser() {
      const profile = _get(this.profiles, this.currentWorkspaceSlug, null);
      return _get(profile, 'analystUser', true) ||  _get(profile, 'adminUser', true) ||  _get(profile, 'superAdminUser', true)
    },

    headerHeight() {
      return this._headerHeight;
    },

    showSponsorshipPopup() {
      return this.$store.state.openSponsorshipPopup;
    },

    showWorkspaceCopyPopup() {
      return this.$store.state.openCopyWorkspacePopup;
    },

    showCompanyCopyPopup() {
      return this.$store.state.openCopyCompanyPopup;
    },

    navigation() {
      let homeNavigation = {name: 'Home', href: '#', icon: HomeIcon, count: undefined, current: false};
      let workspacesNavigation = {
        name: 'My Workspaces',
        icon: undefined,
        section: 'dynamic',
        current: false,
        count: undefined,
        externalWrapperClass: 'py-2 border-t border-t-transparent border-b border-past-blue-light',
        children: [
          {
            name: 'New',
            icon: PlusIcon,
            type: 'button',
            onClickCallback: function (component) {
              component.$store
                  .dispatch('createWorkspace', {})
                  .then(function (workspace) {
                    this.switchToAnotherWorkspace(workspace.slug)
                        .then(() => {
                          this.openInnovationProjectEditor = true;
                          this.editInnovationProject = workspace;
                        });
                  }.bind(this));
            }.bind(this)
          },
        ],
        actions: undefined
      };

      if (this.workspaces !== null) {
        for (const wsSlug in this.workspaces) {
          const workspace = this.workspaces[wsSlug];
          if (workspace.archived || !workspace.active) {
            continue;
          }

          const profile = _get(this.profiles, wsSlug, null);
          const isWorkspaceOwner = _get(profile, 'workspaceOwner', false);
          const workspaceAlias = _get(profile, 'preferences.workspaceAlias', null);
          let workspacesNavigationChild = {
            id: workspace.slug,
            name: isWorkspaceOwner ? workspace.name : (workspaceAlias !== null ? workspaceAlias : workspace.name),
            icon: DocumentReportIcon,
            current: _get(this.$store.state.currentWorkspace, 'slug', null) === workspace.slug,
            onClick: function (component, isAlreadySelected) {
              if(!isAlreadySelected) {
                this.switchToAnotherWorkspace(workspace.slug);
              } else {
                this.$store.commit('setDisplaySearchResult', true);
                this.search(false);
                this.$store.commit('setCurrentViewChannel', null);
              }
            }.bind(this),
            actions: [
              {
                name: 'Rename',
                icon: PencilIcon,
                onClickCallback: function (component) {
                  component.$store.commit('editMenuEntry', {
                    id: workspace.slug,
                    meta: {
                      callbackName: isWorkspaceOwner ? 'renameWorkspace' : 'editUserProfile',
                      targetPropertyName: 'workspaceName',
                      idPropertyName: 'workspaceSlug'
                    }
                  });
                  setTimeout(function () {
                        component.$refs[`edit-menu-entry-${workspace.slug}`].focus();
                      }, 200
                  )
                }
              },
              // {
              //   // name: 'See innovation project',
              //   name: 'See / Edit',
              //   icon: EyeIcon,
              //   onClickCallback: function (component) {
              //     this.editInnovationProject = workspace;
              //     this.openInnovationProjectEditor = true;
              //   }.bind(this)
              // },
              {
                name: 'See / Edit',
                icon: PencilAltIcon,
                onClickCallback: function (component) {
                  this.editInnovationProject = workspace;
                  this.openInnovationProjectEditor = true;
                }.bind(this)
              },
            ]
          };

          if (_get(profile, 'analystUser', true) ||  _get(profile, 'adminUser', true) ||  _get(profile, 'superAdminUser', true)) {
            workspacesNavigationChild.actions.push({
              name: 'Duplicate',
              icon: DocumentDuplicateIcon,
              onClickCallback: function (component) {
                component.$store.commit('setWorkspaceForCopyWorkspacePopup', workspace);
                component.$store.commit('setOpenCopyWorkspacePopup', true);
              }
            });
          }

          workspacesNavigationChild.actions.push({
            name: 'Invite team members',
            icon: UserAddIcon,
            divider: 'top',
            onClickCallback: function (component) {
              component.$store.commit('setWorkspaceForSponsorshipPopup', workspace);
              component.$store.commit('setOpenSponsorshipPopup', true);
            }.bind(this)
          });


          if (_get(this.$store.state.currentWorkspace, 'slug', null) !== workspace.slug && _get(this.$store.state.profiles[workspace.slug], 'workspaceOwner', false)) {
            workspacesNavigationChild.actions.push({
              name: 'Archive',
              icon: ArchiveIcon,
              iconClass: 'text-red-500',
              divider: 'top',
              onClickCallback: function (component) {
                component.$store.dispatch("editWorkspace", {
                  workspaceSlug: workspace.slug,
                  archived: true,
                  notification: {
                    title: "'" + workspace.name + '\' has been archived',
                    body: null,
                    type: 'success',
                  }
                });
              }
            })
          }

          workspacesNavigation.children.push(workspacesNavigationChild);
        }
      }

      let currentWorkspaceNavigation = {
        name: 'Current Project',
        icon: HomeIcon,
        section: 'static',
        current: false,
        count: undefined,
        notDisplay: true,
        externalWrapperClass: 'py-2 border-b border-gray-300',
        children: [
          // {
          //   name: 'Recommendations',
          //   href: '#',
          //   icon: EyeIcon,
          //   type: 'button',
          //   onClickCallback: function (component) {
          //     component.$store.commit('setDisplayRecommendations', true)
          //     // TODO: Need to implement the feature
          //     component.$store.commit('addNotification', {
          //       title: 'TODO',
          //       body: 'Not yet implemented',
          //       type: 'warning',
          //     })
          //   }
          // },
          {
            name: 'Search',
            icon: SearchIcon,
            type: 'button',
            onClickCallback: function (component) {
              component.$store.commit('setDisplaySearchResult', true);
              this.search(false);
              this.$store.commit('setCurrentViewChannel', null);
            }.bind(this)
          },
          {
            name: 'Invite',
            icon: UserAddIcon,
            type: 'button',
            onClickCallback: function (component) {
              component.$store.commit('setOpenSponsorshipPopup', true)
            }
          },
          {
            name: 'New list',
            icon: PlusIcon,
            type: 'button',
            onClickCallback: function (component) {
              this.displaySaveToListDialog(true, null);
            }.bind(this)
          }
        ],
        actions: undefined
      };

      if (this.currentWorkspace !== null && !_isUndefined(this.currentWorkspace.channels)) {
        let primaryChannelsOrder = this.currentWorkspace.options['primary_channels_order'];
        if (_isUndefined(primaryChannelsOrder)) {
          primaryChannelsOrder = ["company", "assessment", "document", "topic", "search"];
        }
        const channelMeta = {
          assessment: {label: 'Startup Assessment Report', icon: PresentationChartLineIcon,},
          document: {label: 'Current project Documents', icon: DocumentIcon,},
          company: {label: 'My Lists', icon: OfficeBuildingIcon,},
          topic: {label: 'Curated Topics', icon: PresentationChartBarIcon,},
          search: {label: 'Search history', icon: DocumentSearchIcon,},
        };

        let sortedChannels = this.currentWorkspace.channels.sort(function (a, b) {
          const aType = primaryChannelsOrder.indexOf(a.name.split('.')[0]);
          const bType = primaryChannelsOrder.indexOf(b.name.split('.')[0]);

          // Trie d'abord sur le path primaire mais si égalité on prend le sortOrder
          return (aType === bType) ? (a.sortOrder - b.sortOrder) : (aType - bType)
        });


        let currentPrimaryChannel = null;
        let currentPrimaryChannelPath = null;
        let currentPrimaryChannelCounter = null;
        for (const channel of sortedChannels) {
          if (channel.archived || !channel.active) {
            continue;
          }

          let currentMemberProfile = this.getCurrentMemberProfile();
          if (channel.visibility === 4
              || channel.name === 'assessment.benchmark'
              || ('company.not-relevant' === channel.name && !(_get(currentMemberProfile, 'superAdminUser', false) || _get(currentMemberProfile, 'adminUser', false) || _get(currentMemberProfile, 'analystUser', false)))) { // NO_VISIBILITY => 4
            continue;
          }

          let primaryChannelPath = channel.name.split('.')[0];
          if (currentPrimaryChannelPath == null || primaryChannelPath !== currentPrimaryChannelPath) {
            if (currentPrimaryChannelCounter !== null) {
              currentPrimaryChannel.count = currentPrimaryChannelCounter;
            }

            currentPrimaryChannel = {
              name: channelMeta[primaryChannelPath].label,
              icon: channelMeta[primaryChannelPath].icon,
              href: undefined,
              count: "",
              children: [],
              actions: undefined
            };

            if(primaryChannelPath === 'company') {
              currentPrimaryChannel.actions = [ {
                name: 'New',
                icon: PlusIcon,
                onClickCallback: function (component) {
                  this.displaySaveToListDialog(true, null);
                }.bind(this)
              }]
            }

            currentPrimaryChannelPath = primaryChannelPath;
            currentWorkspaceNavigation.children.push(currentPrimaryChannel);
          }

          let counter = '';
          let actions = undefined;
          if (primaryChannelPath === 'assessment') {
            counter = channel.counters['system.finalized'] + '/' + channel.counters['system.count'];
            // if (channel.name.split('.')[1] === 'all') {
            //   currentPrimaryChannelCounter = counter;
            // }
          } else if (primaryChannelPath === 'company') {
            counter = "" + channel.counters['system.count'];
            // if (channel.name.split('.')[1] === 'relevant') {
            //   currentPrimaryChannelCounter = counter;
            // }

            actions = [
              {
                name: 'Rename',
                icon: PencilIcon,
                onClickCallback: function (component) {
                  component.$store.commit('editMenuEntry', {
                    id: channel.uuid,
                    meta: {
                      callbackName: 'renameChannel',
                      targetPropertyName: 'label',
                      idPropertyName: 'channelUuid'
                    }
                  });
                  setTimeout(function () {
                        component.$refs[`edit-menu-entry-${channel.uuid}`][0].focus();
                      }, 200
                  )
                }
              },
            ];

            if (channel.name !== this.currentViewChannel && channel.name !== 'company.not-relevant' && channel.name !== 'company.relevant') {
              actions.push({
                name: 'Archive',
                icon: ArchiveIcon,
                iconClass: 'text-red-500',
                divider: 'top',
                onClickCallback: function (component) {
                  component.$store.dispatch("editChannel", {
                    channelUuid: channel.uuid,
                    archived: true,
                    notification: {
                      title: "'" + channel.label + '\' has been archived',
                      body: null,
                      type: 'success',
                    }
                  });
                }
              })
            }
          }

          let currentChannel = {
            id: channel.uuid,
            name: channel.label,
            icon: undefined,
            count: counter,
            current: this.currentViewChannel !== null && channel.name === this.currentViewChannel,
            actions: actions
          };

          if('assessment.report' === channel.name) {
            currentChannel.onClickCallback = function (component) {
              this.search(true, {
                slugs: this.reports.map(n => n.companyId)
              });

              this.$store.commit('setCurrentViewChannel', this.companyReportsChannelUuid);

            }.bind(this);
          } else if('company.relevant' === channel.name) {
            currentChannel.onClickCallback = function (component) {
              this.search(true, {
                slugs: this.relevantCompanies
              });

              this.$store.commit('setCurrentViewChannel', this.relevantCompaniesChannelUuid);
            }.bind(this);
          } else if('company.not-relevant' === channel.name) {
            currentChannel.onClickCallback = function (component) {
              this.search(true, {
                slugs: this.notRelevantCompanies
              });

              this.$store.commit('setCurrentViewChannel', this.notRelevantCompaniesChannelUuid);
            }.bind(this);
          } else if(channel.name.startsWith('company.custom')) {
            currentChannel.onClickCallback = function (component) {
              if(this.isDetailedChannelLoaded(currentChannel.name)) {
                this.search(true, {
                  slugs: this.getChannelCompanies(currentChannel.name)
                });

                this.$store.commit('setCurrentViewChannel', this.currentChannel.uuid);
              } else {
                this.$store.dispatch("loadDetailedChannels", {
                  channelIds: [currentChannel.id],
                  workspaceSlug: this.currentWorkspace.slug
                }).then(function (detailedChannel) {
                  detailedChannel = detailedChannel.pop();
                  this.search(true, {
                    slugs: this.getChannelCompanies(detailedChannel.name)
                  });

                  this.$store.commit('setCurrentViewChannel', detailedChannel.uuid);
                }.bind(this))
              }
            }.bind(this);
          }

          currentPrimaryChannel.children.push(currentChannel);
        }

        if (currentPrimaryChannelCounter !== null) {
          currentPrimaryChannel.count = currentPrimaryChannelCounter;
        }

      }

      return [
        // homeNavigation,
        workspacesNavigation,
        currentWorkspaceNavigation,
      ];
    },

    ...mapState({
      workspaces: 'workspaces',
      profiles: 'profiles',
      currentWorkspace: 'currentWorkspace',
      currentViewChannel: 'currentViewChannel',
      notifications: 'uiNotifications',
    }),

    ...mapGetters({
      currentViewChannel: "getCurrentViewChannel",
      relevantCompaniesChannelUuid: 'getRelevantCompaniesChannelUuid',
      notRelevantCompaniesChannelUuid: 'getNotRelevantCompaniesChannelUuid',
      companyReportsChannelUuid: 'getCompanyReportsChannelUuid',
      companyBenchmarksChannelUuid: 'getCompanyBenchmarksChannelUuid',
      relevantCompanies: 'getRelevantCompanies',
      notRelevantCompanies: 'getNotRelevantCompanies',
      reports: 'getReports',
      currentInnovation: 'getCurrentInnovation',
      getChannelCompanies: 'getChannelCompanies',
      isDetailedChannelLoaded: 'isDetailedChannelLoaded',
      isInCustomCompanyChannel: 'isInCustomCompanyChannel',
      isInNotRelevantChannel: 'isInNotRelevantChannel',
      isInRelevantChannel: 'isInRelevantChannel',
      isInReportChannel: 'isInReportChannel',
      getChannelUuid: 'getChannelUuid',
      currentWorkspaceSlug: 'getCurrentWorkspaceSlug',
      getWorkspaceMemberProfile: 'getWorkspaceMemberProfile',
    }),


    notificationCount() {
      return this.$store.state.globalNotifications.length;
    },
  }
}
</script>